<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 3; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="hiring-details-main">
      <div class="page-heading d-flex align-items-center mb-3">
        <img
          src="../../assets/bckarrow.svg"
          class="pointer mr-2"
          @click="gobackpointer"
          alt=""
        />
        <div class="main-head">
          <span>
            {{ $route.query.jobTitle }}
          </span>
        </div>
      </div>
      <div class="jduppercontainer d-flex">
        <div
          class="jd-firstcard"
          :style="
            !roles.includes('GET_KANBAN') &&
            !roles.includes('ACCEPT_REJECT_APPLICATION')
              ? 'width: 100%;'
              : ''
          "
        >
          <!-- funnel Graph Code Starts -->
          <div
            class="m-2"
            style="
              font-weight: 600;
              font-size: 14px;
              line-height: 21px;
              color: #030229;
              opacity: 0.7;
            "
          >
            JD Stats
          </div>
          <div class="d-flex justify-content-center">
            <div style="width: 100%">
              <b-row>
                <b-col cols="10">
                  <div id="funnel"></div>
                </b-col>
                <b-col cols="2">
                  <div class="funnel-textShow mr-2">
                    <div class="d-flex">
                      <div>
                        <img src="../../assets/workbenchPosition.svg" alt="" />
                      </div>
                      <div class="ml-2">
                        <div class="funnelDataNum">{{ totalPosition }}</div>
                        <div class="funnelData-text">Position</div>
                      </div>
                    </div>
                    <hr class="mt-1" />
                    <div class="d-flex">
                      <div>
                        <img
                          src="../../assets/workbenchCandidates.svg"
                          alt=""
                        />
                      </div>
                      <div class="ml-2">
                        <div class="funnelDataNum">{{ totalCandidates }}</div>
                        <div class="funnelData-text">Candidates</div>
                      </div>
                    </div>
                    <hr class="mt-1" />
                    <div class="d-flex">
                      <div>
                        <img src="../../assets/workbenchSelected.svg" alt="" />
                      </div>
                      <div class="ml-2">
                        <div class="funnelDataNum">{{ totalselectedCand }}</div>
                        <div class="funnelData-text">Selected</div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <div class="ml-3">
          <div
            class="jdd-purple relativeclass"
            v-if="roles.includes('GET_KANBAN')"
          >
            <div class="d-flex">
              <div class="jdd-card-text">Get Kanban View!</div>
              <div>
                <img src="../../assets/lightPruple.svg" alt="" />
              </div>
            </div>
            <div class="kanbancard-view pointer" @click="kanbanBoard()">
              View
            </div>
          </div>
          <div
            class="jdd-yellow relativeclass mt-3"
            v-if="roles.includes('ACCEPT_REJECT_APPLICATION')"
          >
            <div class="d-flex align-items-center">
              <div class="jdd-card-text">View Applications</div>
            </div>
            <div class="d-flex align-items-center justify-content-between mt-2">
              <div class="jdd-app-num">
                <img class="mr-2" src="../../assets/whiteAPp.svg" alt="" />
                {{ allCandTotal }}
              </div>
              <div class="jdd-kanbancard-view pointer" @click="openApp()">
                View
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          jdtablecontainer
          slectedcandidate-table-container
          relativeclass
          mt-3
        "
      >
        <div class="d-flex align-items-center justify-content-between">
          <div class="report-cards-head">List Of Candidates</div>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-3">
          <div
            class="search-bar mr-3"
            :style="!menuStatus ? 'width:60%;' : 'width:55%'"
          >
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
            <b-form-input
              class="search-input"
              type="search"
              placeholder="Search Candidates"
              v-model.trim="searchname"
              @keyup="textSearch"
            ></b-form-input>
          </div>
          <div>
            <div class="d-flex switchtext relativeclass align-items-center">
              <div
                class="send-multi-assess-btn d-flex align-items-center pointer"
                v-if="saveAllCandidate.length > 0 && isAssessmentExist"
                @click="openMultiAssessModal"
              >
                <img
                  src="../../assets/img/jddetails/asmtnotdoneicon.svg"
                  alt=""
                />
                <div class="send-multi-asses-text ml-2">
                  Send Multiple Assessment
                </div>
              </div>
              <div
                class="ml-2 relativeclass"
                ref="close-addcandidate"
                v-closable="{
                  exclude: ['close-addcandidate'],
                  handler: 'closeAddCand',
                }"
              >
                <div>
                  <b-button
                    v-if="roles.includes('PUSH_JOB_CANDIDATE')"
                    class="addbtn mr-2"
                    @click="addCandidateToggle = !addCandidateToggle"
                  >
                    <img
                      src="../../assets/Group (6).svg"
                      alt=""
                      class="mr-2 mb-1"
                    />

                    <span class="">Add Candidate</span>
                    <img
                      v-if="!addCandidateToggle"
                      class="ml-2"
                      src="../../assets/img/whitedownarrow.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="ml-2"
                      src="../../assets/img/whiteuparrow.svg"
                      alt=""
                    />
                  </b-button>
                </div>
                <div
                  v-if="addCandidateToggle"
                  class="jd-candidateToggle candidateJd-z-index"
                >
                  <div class="pointer" @click="openExcelModal">
                    Add Multiple Candidates
                  </div>
                  <div class="pointer" @click="openCenterModal">
                    Add from Talent Pool
                  </div>
                  <div class="pointer" @click="goToCanditatePage()">
                    Add New Candidate
                  </div>
                </div>
              </div>

              <div
                class="ml-2 relativeclass"
                ref="close-main-filter"
                v-closable="{
                  exclude: ['close-main-filter', 'select-main-filter'],
                  handler: 'closejDdetailsFilter',
                }"
              >
                <div>
                  <img
                    class="mr-4 pointer"
                    v-b-popover.hover.bottom="'Filter'"
                    src="../../assets/img/talentpool/filtericon.svg"
                    alt=""
                    @click="showfiltercard = !showfiltercard"
                  />
                  <div class="jd-filter-count mb-3" v-if="filtercount != 0">
                    {{ filtercount }}
                  </div>
                </div>

                <div v-if="showfiltercard">
                  <div
                    class="panelist-filtercard d-flex align-items-center"
                    style="top: 38px; right: 33px"
                  >
                    <div>
                      <div
                        @click="showfiltercard = false"
                        class="xMarkCancel pointer"
                      >
                        <img src="../../assets/xmark.svg" alt="" />
                      </div>
                      <b-row>
                        <b-col>
                          <div class="topDiv mt-3">
                            <label class="fieldsetStyle sharelabel"
                              >Source
                            </label>
                            <div
                              class="
                                pl-dropdown-diffy
                                d-flex
                                justify-content-between
                                pointer
                              "
                              ref="source-label"
                              @click="dbfilterdrop = !dbfilterdrop"
                            >
                              <span v-if="sourceof == ''">Choose options</span
                              ><span v-else class="text-capitalize">{{
                                sourceof === "other" ? "Others" : sourceof
                              }}</span>
                              <span
                                ><img
                                  v-if="!dbfilterdrop"
                                  src="../../assets/rec-main-downArrow.svg"
                                  alt=""
                                  class="mr-1"
                                />
                                <img
                                  v-else
                                  src="../../assets/rec-main-upArrow.svg"
                                  alt=""
                                  class="mr-1"
                                />
                              </span>
                            </div>
                            <div
                              v-if="dbfilterdrop"
                              ref="source-list"
                              v-closable="{
                                exclude: ['source-label', 'source-list'],
                                handler: 'closeSource',
                              }"
                              class="pl-dropdown-option-add d-flex"
                            >
                              <b-form-group
                                class="pl-dd-group"
                                v-slot="{ ariaDescribedby }"
                              >
                                <b-form-radio-group
                                  @change="dbfilterdrop = !dbfilterdrop"
                                  class="pl-add-drop w-100"
                                  id="btn-radios-3"
                                  v-model="sourceof"
                                  :options="source_options"
                                  :aria-describedby="ariaDescribedby"
                                  name="radio-btn-stacked"
                                  disabled-field="notEnabled"
                                  buttons
                                  stacked
                                ></b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col>
                          <div class="topDiv mt-3" @click.stop="">
                            <label class="fieldsetStyle">Skills &nbsp;</label>
                            <b-form-tags
                              class="jd-filterinputField"
                              id="input-1"
                              placeholder="Enter Skills"
                              v-model="areaofexp"
                              type="text"
                              invalid-tag-text="Duplicate tag(s)"
                              remove-on-delete
                            ></b-form-tags>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="topDiv mt-3" v-if="isAssessmentExist">
                            <label class="fieldsetStyle sharelabel"
                              >Assessment</label
                            >
                            <div
                              class="
                                pl-dropdown-diffy
                                d-flex
                                justify-content-between
                                pointer
                              "
                              ref="assessment-label"
                              @click="assessdrop = !assessdrop"
                            >
                              <span v-if="assessmentStatus == ''"
                                >Choose options</span
                              ><span v-else>{{ assessmentStatus }}</span>
                              <span
                                ><img
                                  v-if="!assessdrop"
                                  src="../../assets/rec-main-downArrow.svg"
                                  alt=""
                                  class="mr-1"
                                />
                                <img
                                  v-else
                                  src="../../assets/rec-main-upArrow.svg"
                                  alt=""
                                  class="mr-1"
                                />
                              </span>
                            </div>
                            <div
                              v-if="assessdrop"
                              ref="assessment-list"
                              v-closable="{
                                exclude: [
                                  'assessment-label',
                                  'assessment-list',
                                ],
                                handler: 'closeAssessment',
                              }"
                              class="pl-dropdown-option-add d-flex"
                            >
                              <b-form-group
                                class="pl-dd-group"
                                v-slot="{ ariaDescribedby }"
                              >
                                <b-form-radio-group
                                  @change="assessdrop = !assessdrop"
                                  class="pl-add-drop w-100"
                                  id="btn-radios-3"
                                  v-model="assessmentStatus"
                                  :options="assessmentStatus_options"
                                  :aria-describedby="ariaDescribedby"
                                  name="radio-btn-stacked"
                                  disabled-field="notEnabled"
                                  buttons
                                  stacked
                                ></b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          mt-3
                        "
                      >
                        <div
                          class="clearfilter"
                          :class="
                            sourceof == '' &&
                            areaofexp.length == 0 &&
                            assessmentStatus == '' &&
                            filtercount == 0
                              ? 'disabled-text'
                              : 'pointer'
                          "
                          @click="
                            sourceof == '' &&
                            areaofexp.length == 0 &&
                            assessmentStatus == '' &&
                            filtercount == 0
                              ? ''
                              : filtercount == 0
                              ? clearfilter(false)
                              : clearfilter(true)
                          "
                        >
                          Clear Filter
                        </div>
                        <div>
                          <b-button
                            :disabled="
                              sourceof == '' &&
                              areaofexp.length == 0 &&
                              assessmentStatus == ''
                            "
                            class="addbtn"
                            @click="applyJDFilterTest()"
                          >
                            Apply
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="all-JdDetails-main-tabs">
            <div class="tabbed mt-3 mb-0" style="height: calc(100vh - 225px)">
              <b-tabs v-model="tabIndex">
                <b-tab title="Show All" @click="switchTabs('SH')">
                  <div>
                    <!-- table starts -->
                    <div class="table-main">
                      <table
                        :aria-describedby="'Show All'"
                        class="
                          w-100
                          tp-reports-table
                          selected-dash-table
                          jdtablecontent
                        "
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 7%">
                              <span class="mr-1">Source</span>
                              <template v-if="statusValue == 'source'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('source', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 15%" class="text-center">
                              <span class="mr-1">Candidate Name</span>
                              <template v-if="statusValue == 'name'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('name', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th style="width: 15%" class="text-center">
                              <span>Email ID</span>
                              <template v-if="statusValue == 'email'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('email', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 15%" class="text-center">
                              <span>Skills</span>
                            </th>
                            <th style="width: 10%" class="text-center">
                              <span>Rounds Cleared </span>
                              <template v-if="statusValue == `level`">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('level', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('level', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('level', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th style="width: 25%" class="text-center">
                              <span>Actions</span>
                            </th>
                            <th class="text-center" style="width: 13%">
                              <span>Options</span>
                            </th>
                          </tr>
                        </thead>
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                          v-if="
                            searchname !== '' && saveAllCandidate.length === 0
                          "
                        >
                          <img
                            src="../../assets/img/jddetails/nosearchmatch.svg"
                            alt=""
                          />
                          <div class="no-match mt-3">
                            No matching results for
                            <span class="searchtext wordbreak"
                              >"{{ searchname }}"
                            </span>
                          </div>
                        </div>
                        <div
                          style="height: calc(100vh - 370px)"
                          v-else-if="saveAllCandidate.length === 0"
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                            mt-3
                          "
                        >
                          <div>
                            <img src="../../assets/emptyjdillust.svg" alt="" />
                          </div>
                          <div
                            v-if="
                              (sourceof != '' &&
                                saveAllCandidate.length == 0) ||
                              (areaofexp != '' &&
                                saveAllCandidate.length == 0) ||
                              (assessmentStatus != '' &&
                                saveAllCandidate.length == 0)
                            "
                          >
                            <span>No Data </span>
                          </div>
                          <div
                            class="searchnotfound"
                            v-else-if="saveAllCandidate.length == 0"
                          >
                            Please click
                            <strong> "Add Candidate"</strong> button to add
                            candidate details
                          </div>
                        </div>
                        <tbody v-else>
                          <tr
                            class="selected-table-cards"
                            v-for="(Details, index) in saveAllCandidate"
                            :key="index"
                          >
                            <td class="text-center" style="width: 7%">
                              <div
                                v-once
                                class="gridgreencolorDynamic mr-1"
                              ></div>
                              <img
                                v-if="
                                  Details.source == 'other' ||
                                  Details.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </td>

                            <td style="width: 15%" class="text-center">
                              {{ Details.name }}
                            </td>
                            <td style="width: 15%" class="text-center">
                              {{ Details.email }}
                            </td>

                            <td style="width: 15%" class="text-center">
                              <span
                                :id="'tp1' + Details.candidateID"
                                class="defaultCursor"
                                >{{ Details.skills | fnName }}</span
                              >
                              <span>
                                <b-popover
                                  :target="'tp1' + Details.candidateID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="(skill, index) in Details.skills"
                                    :key="skill.id"
                                  >
                                    {{ skill }}
                                    <span
                                      v-if="index != Details.skills.length - 1"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </td>
                            <td style="width: 10%">
                              <template
                                v-if="checkValidRound(Details.kanbanLevel)"
                              >
                                <div
                                  class="text-center"
                                  :class="roundClass(Details.kanbanLevel)"
                                >
                                  Round {{ Details.kanbanLevel }}
                                </div>
                              </template>
                              <template
                                v-else-if="Details.awaitingForApproval !== null"
                              >
                                <div
                                  v-if="Details.awaitingForApproval == '0'"
                                  class="d-flex justify-content-between"
                                >
                                  <div class="jd-opshead-pending text-center">
                                    Pending
                                  </div>
                                  <span
                                    v-b-tooltip.hover.right="
                                      'Approval pending from  Ops Head'
                                    "
                                  >
                                    <img
                                      style="background: #ffe8cc"
                                      class="jd-opshead-icon text-center"
                                      src="../../assets/img/pending-status.svg"
                                      alt="Pending"
                                    />
                                  </span>
                                </div>
                                <div
                                  v-if="Details.awaitingForApproval == '1'"
                                  class="jd-hiderdbox text-center"
                                >
                                  Selected
                                </div>
                                <div
                                  v-if="Details.awaitingForApproval == '2'"
                                  class="d-flex justify-content-between"
                                >
                                  <div class="jd-opshead-rejected text-center">
                                    Rejected
                                  </div>
                                  <span
                                    v-b-tooltip.hover.right="
                                      'Rejected by  Ops Head'
                                    "
                                  >
                                    <img
                                      style="background: #ffd6e0"
                                      class="jd-opshead-icon text-center"
                                      src="../../assets/img/rejected-status.svg"
                                      alt="Rejected"
                                    />
                                  </span>
                                </div>
                              </template>
                              <template v-else>
                                <div
                                  class="jd-hiderdbox text-center"
                                  :class="{
                                    'jd-hiderdbox': Details.kanbanLevel === 'F',
                                    'jd-nibox': Details.kanbanLevel === 'NI',
                                    'jd-onholdbox': Details.kanbanLevel === 'H',
                                    'jd-rejectedbox':
                                      Details.kanbanLevel === 'R',
                                  }"
                                >
                                  {{ getRoundName(Details.kanbanLevel) }}
                                </div>
                              </template>
                            </td>
                            <td style="width: 25%" class="text-center">
                              <div>
                                <div
                                  v-if="Details.documentStatus == 0"
                                  class="align-items-center"
                                >
                                  <img
                                    src="../../assets/rejecteddoc.svg"
                                    alt=""
                                  />
                                  <span class="redDoc ml-1"
                                    >Documents Rejected</span
                                  >
                                </div>
                                <div
                                  v-else-if="
                                    Details.documentStatus == 4 ||
                                    Details.documentStatus == 2
                                  "
                                  @click="viewRequiredDocs(Details.candidateID)"
                                  class="pointer"
                                >
                                  <img
                                    src="../../assets/viewdocuments.svg"
                                    alt=""
                                  />
                                  <span class="greenDoc ml-2"
                                    >View Documents</span
                                  >
                                </div>
                                <div
                                  v-else-if="Details.documentStatus == 3"
                                  class="defaultCursor"
                                >
                                  <img
                                    src="../../assets/requesteddoc.svg"
                                    alt=""
                                  />
                                  <span class="yellowDoc"
                                    >Documents Requested</span
                                  >
                                </div>
                                <div
                                  v-else-if="
                                    Details.documentStatus == 1 ||
                                    Details.documentStatus == null
                                  "
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-center
                                  "
                                >
                                  <div
                                    v-if="
                                      Details.type == 'assesment' &&
                                      Details.kanbanScheduled == true
                                    "
                                  >
                                    <template
                                      v-if="Details['assessmentResponse']"
                                    >
                                      <img
                                        v-if="
                                          Details.assessmentResponse.status ==
                                            2 &&
                                          Details.awaitingForApproval !== '0'
                                        "
                                        v-b-popover.hover.top="
                                          'Assessment Done'
                                        "
                                        src="../../assets/img/jddetails/asmntdoneicon.svg"
                                        alt=""
                                      />
                                      <img
                                        v-if="
                                          Details.assessmentResponse.status ==
                                            0 &&
                                          Details.awaitingForApproval !== '0'
                                        "
                                        class="pointer"
                                        @click="
                                          openAssessmentConfigModal(Details)
                                        "
                                        v-b-popover.hover.top="
                                          'Retrigger Assessment'
                                        "
                                        src="../../assets/img/jddetails/retriggerassessment.svg"
                                        alt=""
                                      />
                                    </template>
                                  </div>

                                  <template
                                    v-if="
                                      Details.kanbanScheduled == false &&
                                      Details.selectionInfo == true &&
                                      Details.kanbanLevel == 'F' &&
                                      Details.awaitingForApproval !== '0'
                                    "
                                  >
                                    <img
                                      v-b-popover.hover.top="'Move to On-Hold'"
                                      class="pointer"
                                      src="../../assets/img/jddetails/selectedcandidateonhold.svg"
                                      alt=""
                                      @click="openFinalOnHold(Details)"
                                    />
                                  </template>

                                  <div
                                    v-if="
                                      Details.type == 'assesment' &&
                                      Details.kanbanScheduled == false &&
                                      Details.kanbanLevel != 'NI' &&
                                      Details.kanbanLevel != 'R' &&
                                      Details.awaitingForApproval !== '0'
                                    "
                                    class="ml-2 pointer"
                                    @click="openAssessmentConfigModal(Details)"
                                    v-b-popover.hover.top="'Trigger Assessment'"
                                  >
                                    <img
                                      src="../../assets/img/jddetails/asmtnotdoneicon.svg"
                                      alt=""
                                    />
                                  </div>

                                  <div
                                    v-if="
                                      (Details.kanbanScheduled == true &&
                                        Details.kanbanLevel === 'F') ||
                                      Details.type == 'f2f' ||
                                      Details.awaitingForApproval == '0'
                                    "
                                  >
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>

                                  <div
                                    v-b-popover.hover.top="'Feedback History'"
                                    @click="history(Details)"
                                    v-if="
                                      Details.kanbanLevel != 0 &&
                                      Details.kanbanLevel != 1
                                    "
                                    class="ml-3 pointer"
                                  >
                                    <img
                                      src="../../assets/img/jddetails/viewhisticon.svg"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>
                                  <div
                                    class="pointer"
                                    v-if="
                                      Details.kanbanScheduled == false &&
                                      Details.kanbanLevel != 'F' &&
                                      Details.kanbanLevel != 'R' &&
                                      Details.kanbanLevel != 'NI' &&
                                      Details.kanbanLevel != 'H' &&
                                      Details.awaitingForApproval !== '0'
                                    "
                                    v-b-popover.hover.top="'Not Interested'"
                                    @click="notInterestedCandidates(Details)"
                                  >
                                    <img
                                      src="../../assets/img/jddetails/niicon.svg"
                                      alt=""
                                      class="ml-3"
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>

                                  <div
                                    v-if="
                                      Details.kanbanScheduled == false &&
                                      Details.kanbanLevel != 'H' &&
                                      (Details.type == 'f2f' ||
                                        Details.kanbanLevel == 'F') &&
                                      Details.awaitingForApproval !== '0'
                                    "
                                  >
                                    <img
                                      v-if="
                                        Details.kanbanLevel != 'R' &&
                                        Details.kanbanLevel != 'NI'
                                      "
                                      v-b-popover.hover.top="
                                        'Schedule Interview'
                                      "
                                      @click="scheduleInterviewModal(Details)"
                                      src="../../assets/img/jddetails/schedicon.svg"
                                      class="ml-3 pointer"
                                      alt=""
                                    />

                                    <img
                                      v-if="Details.kanbanLevel == 'H'"
                                      v-b-popover.hover.top="'Schedule'"
                                      class="ml-3 pointer"
                                      @click="rejectConfirmModal(Details)"
                                      src="../../assets/img/jddetails/schedicon.svg"
                                      alt=""
                                    />
                                  </div>

                                  <div
                                    v-else-if="
                                      Details.kanbanLevel != 'H' &&
                                      (Details.type == 'f2f' ||
                                        Details.kanbanLevel == 'F') &&
                                      Details.kanbanScheduled == true &&
                                      Details.awaitingForApproval !== '0'
                                    "
                                  >
                                    <img
                                      v-b-popover.hover.top="
                                        'Reschedule Interview'
                                      "
                                      @click="reschedule(Details)"
                                      src="../../assets/img/jddetails/reschedicon.svg"
                                      class="ml-3 pointer"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>

                                  <div v-if="Details.cancelMeeting == true">
                                    <img
                                      v-b-popover.hover.top="'Cancel Meeting'"
                                      class="ml-3 pointer"
                                      src="../../assets/img/jddetails/cancelmeeting.svg"
                                      @click="cancelMeeting(Details)"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>

                                  <img
                                    v-b-popover.hover.top="'Action'"
                                    @click="
                                      (!Details.selectionInfo &&
                                        Details.kanbanLevel === 'NI') ||
                                      (!Details.selectionInfo &&
                                        Details.kanbanLevel === 'R') ||
                                      (Details.selectionInfo &&
                                        Details.kanbanLevel === 'R')
                                        ? rejectConfirmModal(Details)
                                        : !Details.selectionInfo
                                        ? openGiveFeedbackModal(Details)
                                        : openFinalAction(Details)
                                    "
                                    v-if="
                                      (Details.kanbanLevel === 'H' &&
                                        Details.awaitingForApproval != '0') ||
                                      Details.kanbanLevel === 'NI' ||
                                      Details.kanbanLevel == 'R'
                                    "
                                    src="../../assets/img/jddetails/Action.svg"
                                    class="ml-3 pointer"
                                    alt=""
                                  />
                                  <!-- -->
                                  <div
                                    class="pointer"
                                    v-if="Details.kanbanScheduled == true"
                                    v-b-popover.hover.top="'Give Feedback'"
                                    @click="openGiveFeedbackModal(Details)"
                                  >
                                    <!-- feedback -->
                                    <img
                                      src="../../assets/img/jddetails/givefeedbackicon.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>
                                  <div v-if="Details['assessmentResponse']">
                                    <img
                                      v-if="
                                        Details.kanbanScheduled == true &&
                                        Details.assessmentResponse.status ==
                                          0 &&
                                        Details.kanbanLevel != 'R' &&
                                        Details.kanbanLevel != 'NI' &&
                                        Details.kanbanLevel != 'F'
                                      "
                                      v-b-popover.hover.top="'Yet to Start'"
                                      class="ml-3"
                                      src="../../assets/img/sidebar/red.svg"
                                      alt=""
                                    />
                                    <img
                                      v-if="
                                        Details.type == 'assesment' &&
                                        Details.kanbanScheduled == true &&
                                        Details.assessmentResponse.status ==
                                          1 &&
                                        Details.kanbanLevel != 'R' &&
                                        Details.kanbanLevel != 'NI'
                                      "
                                      v-b-popover.hover.top="'Ongoing'"
                                      class="ml-3"
                                      src="../../assets/img/sidebar/yellow.svg"
                                      alt=""
                                    />
                                    <img
                                      v-if="
                                        Details.type == 'assesment' &&
                                        Details.kanbanScheduled == true &&
                                        Details.assessmentResponse.status ==
                                          2 &&
                                        Details.kanbanLevel != 'R' &&
                                        Details.kanbanLevel != 'NI'
                                      "
                                      @click="assignMarksSuccess(Details)"
                                      v-b-popover.hover.top="
                                        Details.assessmentResponse
                                          .evaluationStatus == true
                                          ? 'View Marks'
                                          : ' The test has been taken, but it has not been evaluated'
                                      "
                                      class="ml-3"
                                      :style="
                                        Details.assessmentResponse
                                          .evaluationStatus == true
                                          ? 'cursor:pointer'
                                          : 'opacity:50%'
                                      "
                                      src="../../assets/img/sidebar/green.svg"
                                      alt=""
                                    />
                                  </div>
                                  <div v-else>
                                    <img
                                      src="../../assets/img/jddetails/dash.svg"
                                      class="ml-3"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td style="width: 13%">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  text-center
                                  ml-4
                                "
                              >
                                <b-button variant="outline">
                                  <img
                                    @click="downloadResume(Details.resume)"
                                    v-b-popover.hover.top="'Download Resume'"
                                    src="../../assets/img/jddetails/download-jddetail.svg"
                                    alt=""
                                  />
                                </b-button>

                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(Details)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  class="ml-2 pointer"
                                  alt=""
                                />

                                <img
                                  v-if="
                                    Details.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  v-b-popover.hover.top="'View'"
                                  @click="viewCandidate(Details)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Hired" @click="switchTabs('F')">
                  <div>
                    <!-- table starts -->
                    <div class="table-main">
                      <table
                        :aria-describedby="'Hired'"
                        class="
                          w-100
                          tp-reports-table
                          selected-dash-table
                          jdtablecontent
                        "
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 7%">
                              <span class="mr-1">Source</span>
                              <template v-if="statusValue == 'source'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('source', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 27%" class="text-center">
                              <span class="mr-1">Candidate Name</span>
                              <template v-if="statusValue == 'name'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('name', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th style="width: 20%" class="text-center">
                              <span>Email ID</span>
                              <template v-if="statusValue == 'email'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('email', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 20%" class="text-center">
                              <span>Skills</span>
                            </th>

                            <th style="width: 13%" class="text-center">
                              <span>Actions</span>
                            </th>
                            <th class="text-center" style="width: 13%">
                              <span>Options</span>
                            </th>
                          </tr>
                        </thead>
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                          v-if="
                            searchname !== '' && saveAllCandidate.length === 0
                          "
                        >
                          <img
                            src="../../assets/img/jddetails/nosearchmatch.svg"
                            alt=""
                          />
                          <div class="no-match mt-3">
                            No matching results for
                            <span class="searchtext wordbreak"
                              >"{{ searchname }}"
                            </span>
                          </div>
                        </div>
                        <div
                          v-else-if="
                            saveAllCandidate == '' || saveAllCandidate == null
                          "
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            mt-3
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                        >
                          <div>
                            <img src="../../assets/emptyjdillust.svg" alt="" />
                          </div>
                          <div
                            v-if="
                              (sourceof != '' &&
                                saveAllCandidate.length == 0) ||
                              (areaofexp != '' &&
                                saveAllCandidate.length == 0) ||
                              (assessmentStatus != '' &&
                                saveAllCandidate.length == 0)
                            "
                          >
                            <span>No Data </span>
                          </div>
                          <div v-else-if="saveAllCandidate.length == 0">
                            <span class="searchnotfound">
                              There are no
                              <strong>'HIRED' </strong> candidates</span
                            >
                          </div>
                        </div>
                        <tbody v-else>
                          <tr
                            class="selected-table-cards"
                            v-for="(Details, index) in saveAllCandidate"
                            :key="index"
                          >
                            <td class="text-center" style="width: 7%">
                              <div
                                v-once
                                class="gridgreencolorDynamic mr-1"
                              ></div>
                              <img
                                v-if="
                                  Details.source == 'other' ||
                                  Details.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </td>

                            <td style="width: 27%" class="text-center">
                              {{ Details.name }}
                            </td>
                            <td style="width: 20%" class="text-center">
                              {{ Details.email }}
                            </td>

                            <td style="width: 20%" class="text-center">
                              <span
                                :id="'tp2' + Details.candidateID"
                                class="defaultCursor"
                                >{{ Details.skills | fnName }}</span
                              >
                              <span>
                                <b-popover
                                  :target="'tp2' + Details.candidateID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="skill in Details.skills"
                                    :key="skill.id"
                                  >
                                    {{ skill }}
                                    <span
                                      v-if="index != Details.skills.length - 1"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </td>
                            <td style="width: 13%" class="text-center">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                "
                              >
                                <div
                                  v-if="
                                    Details.kanbanScheduled == false &&
                                    Details.selectionInfo == true &&
                                    Details.kanbanLevel == 'F' &&
                                    Details.awaitingForApproval !== '0'
                                  "
                                >
                                  <img
                                    v-b-popover.hover.top="'Move to On-Hold'"
                                    class="pointer"
                                    src="../../assets/img/jddetails/selectedcandidateonhold.svg"
                                    alt=""
                                    @click="openFinalOnHold(Details)"
                                  />
                                </div>

                                <div
                                  v-if="
                                    Details.kanbanLevel != 0 &&
                                    Details.kanbanLevel != 1
                                  "
                                  v-b-popover.hover.top="'Feedback History'"
                                  @click="history(Details)"
                                  class="ml-2 pointer"
                                >
                                  <img
                                    src="../../assets/img/jddetails/viewhisticon.svg"
                                    alt=""
                                  />
                                </div>

                                <div
                                  v-if="
                                    Details.type == 'f2f' &&
                                    Details.documentStatus != null &&
                                    !Details.documentStatus
                                  "
                                  v-b-popover.hover.top="
                                    'Documents Not Uploaded'
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/reschedicondisabled.svg"
                                    alt=""
                                    class="ml-3"
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.kanbanScheduled == false &&
                                    Details.kanbanLevel != 'H' &&
                                    (Details.type == 'f2f' ||
                                      Details.kanbanLevel == 'F') &&
                                    Details.awaitingForApproval !== '0'
                                  "
                                >
                                  <img
                                    v-if="
                                      Details.kanbanLevel != 'R' &&
                                      Details.kanbanLevel != 'NI'
                                    "
                                    v-b-popover.hover.top="'Schedule Interview'"
                                    @click="scheduleInterviewModal(Details)"
                                    src="../../assets/img/jddetails/schedicon.svg"
                                    class="ml-3 pointer"
                                    alt=""
                                  />

                                  <img
                                    v-if="Details.kanbanLevel == 'R'"
                                    v-b-popover.hover.top="'Schedule'"
                                    class="ml-3 pointer"
                                    @click="rejectConfirmModal(Details)"
                                    src="../../assets/img/jddetails/rejschedicon.svg"
                                    alt=""
                                  />
                                  <img
                                    v-if="Details.kanbanLevel == 'NI'"
                                    v-b-popover.hover.top="'Schedule'"
                                    class="ml-3 pointer"
                                    @click="rejectConfirmModal(Details)"
                                    src="../../assets/img/jddetails/schedicon.svg"
                                    alt=""
                                  />
                                  <img
                                    v-if="Details.kanbanLevel == 'H'"
                                    v-b-popover.hover.top="'Schedule'"
                                    class="ml-3 pointer"
                                    @click="rejectConfirmModal(Details)"
                                    src="../../assets/img/jddetails/schedicon.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.kanbanLevel != 'H' &&
                                    (Details.type == 'f2f' ||
                                      Details.kanbanLevel == 'F') &&
                                    Details.kanbanScheduled == true &&
                                    Details.awaitingForApproval !== '0'
                                  "
                                >
                                  <img
                                    v-b-popover.hover.top="
                                      'Reschedule Interview'
                                    "
                                    @click="reschedule(Details)"
                                    src="../../assets/img/jddetails/reschedicon.svg"
                                    class="ml-3 pointer"
                                    alt=""
                                  />
                                </div>

                                <div v-if="Details.cancelMeeting == true">
                                  <img
                                    v-b-popover.hover.top="'Cancel Meeting'"
                                    class="ml-3 pointer"
                                    src="../../assets/img/jddetails/cancelmeeting.svg"
                                    @click="cancelMeeting(Details)"
                                    alt=""
                                  />
                                </div>
                                <img
                                  v-b-popover.hover.top="'Action'"
                                  @click="
                                    !Details.selectionInfo
                                      ? rejectConfirmModal(Details)
                                      : openFinalAction(Details)
                                  "
                                  v-if="
                                    Details.kanbanLevel === 'H' &&
                                    Details.selectionInfo == true
                                  "
                                  src="../../assets/img/jddetails/Action.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <!-- -->
                                <div
                                  class="pointer"
                                  v-if="Details.kanbanScheduled == true"
                                  v-b-popover.hover.top="'Give Feedback'"
                                  @click="openGiveFeedbackModal(Details)"
                                >
                                  <!-- feedback -->
                                  <img
                                    src="../../assets/img/jddetails/givefeedbackicon.svg"
                                    class="ml-3"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </td>
                            <td style="width: 13%" class="text-center">
                              <div
                                class="d-flex align-items-center text-center"
                              >
                                <b-button variant="outline">
                                  <img
                                    @click="downloadResume(Details.resume)"
                                    v-b-popover.hover.top="'Download'"
                                    src="../../assets/img/jddetails/download-jddetail.svg"
                                    alt=""
                                    class=""
                                  />
                                </b-button>

                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(Details)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  class="ml-2 pointer"
                                  alt=""
                                />

                                <img
                                  v-if="
                                    Details.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  v-b-popover.hover.top="'View'"
                                  @click="viewCandidate(Details)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Not Interested" @click="switchTabs('NI')">
                  <div>
                    <!-- table starts -->
                    <div class="table-main">
                      <table
                        :aria-describedby="'Not Interested'"
                        class="
                          w-100
                          tp-reports-table
                          selected-dash-table
                          jdtablecontent
                        "
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 7%">
                              <span class="mr-1">Source</span>
                              <template v-if="statusValue == 'source'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('source', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 27%" class="text-center">
                              <span class="mr-1">Candidate Name</span>
                              <template v-if="statusValue == 'name'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('name', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th style="width: 20%" class="text-center">
                              <span>Email ID</span>
                              <template v-if="statusValue == 'email'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('email', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 15%" class="text-center">
                              <span>Skills</span>
                            </th>
                            <th style="width: 18%" class="text-center">
                              <span>Actions</span>
                            </th>
                            <th class="text-center" style="width: 13%">
                              <span>Options</span>
                            </th>
                          </tr>
                        </thead>
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                          v-if="
                            searchname !== '' && saveAllCandidate.length === 0
                          "
                        >
                          <img
                            src="../../assets/img/jddetails/nosearchmatch.svg"
                            alt=""
                          />
                          <div class="no-match mt-3">
                            No matching results for
                            <span class="searchtext wordbreak"
                              >"{{ searchname }}"
                            </span>
                          </div>
                        </div>
                        <div
                          v-else-if="
                            saveAllCandidate == '' || saveAllCandidate == null
                          "
                          style="height: calc(100vh - 370px)"
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            mt-3
                            justify-content-center
                          "
                        >
                          <div>
                            <img src="../../assets/emptyjdillust.svg" alt="" />
                          </div>
                          <div
                            v-if="
                              (sourceof != '' &&
                                saveAllCandidate.length == 0) ||
                              (areaofexp != '' &&
                                saveAllCandidate.length == 0) ||
                              (assessmentStatus != '' &&
                                saveAllCandidate.length == 0)
                            "
                          >
                            <span>No Data </span>
                          </div>
                          <div v-else-if="saveAllCandidate.length == 0">
                            <span class="searchnotfound">
                              There are no
                              <strong>'NOT INTERESTED' </strong>
                              candidates</span
                            >
                          </div>
                        </div>
                        <tbody v-else>
                          <tr
                            class="selected-table-cards"
                            v-for="(Details, index) in saveAllCandidate"
                            :key="index"
                          >
                            <td class="text-center" style="width: 7%">
                              <div
                                v-once
                                class="gridgreencolorDynamic mr-1"
                              ></div>
                              <img
                                v-if="
                                  Details.source == 'other' ||
                                  Details.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </td>

                            <td style="width: 27%" class="text-center">
                              {{ Details.name }}
                            </td>
                            <td style="width: 20%" class="text-center">
                              {{ Details.email }}
                            </td>

                            <td style="width: 15%" class="text-center">
                              <span
                                :id="'tp3' + Details.candidateID"
                                class="defaultCursor"
                                >{{ Details.skills | fnName }}</span
                              >
                              <span>
                                <b-popover
                                  :target="'tp3' + Details.candidateID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="skill in Details.skills"
                                    :key="skill.id"
                                  >
                                    {{ skill }}
                                    <span
                                      v-if="index != Details.skills.length - 1"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </td>
                            <td style="width: 18%" class="text-center">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                "
                              >
                                <div
                                  v-if="
                                    Details.type == 'assesment' &&
                                    Details.documentStatus != null &&
                                    !Details.documentStatus
                                  "
                                  v-b-popover.hover.top="
                                    'Documents Not Uploaded'
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/retriggerassessmentdisabled.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-else-if="
                                    Details.type == 'assesment' &&
                                    Details.kanbanScheduled == true
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/asmntdoneicon.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.type == 'assesment' &&
                                    Details.kanbanScheduled == false &&
                                    Details.documentStatus != null &&
                                    Details.documentStatus == true
                                  "
                                  class="ml-2"
                                  v-b-popover.hover.top="'Action'"
                                  @click="rejectConfirmModal(Details)"
                                >
                                  <img
                                    src="../../assets/img/jddetails/Action.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.kanbanLevel != 0 &&
                                    Details.kanbanLevel != 1
                                  "
                                  v-b-popover.hover.top="'Feedback History'"
                                  @click="history(Details)"
                                  class="ml-2 pointer"
                                >
                                  <img
                                    src="../../assets/img/jddetails/viewhisticon.svg"
                                    alt=""
                                  />
                                </div>
                                <div v-else>
                                  <img
                                    src="../../assets/img/jddetails/dash.svg"
                                    class="ml-3"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.type == 'f2f' &&
                                    Details.documentStatus != null &&
                                    !Details.documentStatus
                                  "
                                  v-b-popover.hover.top="
                                    'Documents Not Uploaded'
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/reschedicondisabled.svg"
                                    alt=""
                                    class="ml-3"
                                  />
                                </div>
                                <div
                                  v-else-if="
                                    Details.kanbanScheduled == false &&
                                    Details.kanbanLevel != 'F' &&
                                    Details.kanbanLevel != 'H'
                                  "
                                >
                                  <img
                                    v-b-popover.hover.top="'Action'"
                                    @click="rejectConfirmModal(Details)"
                                    src="../../assets/img/jddetails/Action.svg"
                                    class="ml-3 pointer"
                                    alt=""
                                  />
                                </div>
                                <div v-else>
                                  <img
                                    src="../../assets/img/jddetails/dash.svg"
                                    class="ml-3"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </td>
                            <td style="width: 13%" class="text-center">
                              <div
                                class="d-flex align-items-center text-center"
                              >
                                <b-button variant="outline">
                                  <img
                                    @click="downloadResume(Details.resume)"
                                    v-b-popover.hover.top="'Download'"
                                    src="../../assets/img/jddetails/download-jddetail.svg"
                                    alt=""
                                  />
                                </b-button>

                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(Details)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  class="ml-2 pointer"
                                  alt=""
                                />

                                <img
                                  v-if="
                                    Details.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  v-b-popover.hover.top="'View'"
                                  @click="viewCandidate(Details)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="On-Hold" @click="switchTabs('H')">
                  <div>
                    <!-- table starts -->
                    <div class="table-main">
                      <table
                        :aria-describedby="'On-Hold'"
                        class="
                          w-100
                          tp-reports-table
                          selected-dash-table
                          jdtablecontent
                        "
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 7%">
                              <span class="mr-1">Source</span>
                              <template v-if="statusValue == 'source'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('source', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th class="text-center" style="width: 25%">
                              <span class="mr-1">Candidate Name</span>
                              <template v-if="statusValue == 'name'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('name', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th class="text-center" style="width: 20%">
                              <span>Email ID</span>
                              <template v-if="statusValue == 'email'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('email', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th class="text-center" style="width: 20%">
                              <span>Skills</span>
                            </th>
                            <th style="width: 15%" class="text-center">
                              <span>Actions</span>
                            </th>
                            <th style="width: 13%" class="text-center">
                              <span>Options</span>
                            </th>
                          </tr>
                        </thead>
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                          v-if="
                            searchname !== '' && saveAllCandidate.length === 0
                          "
                        >
                          <img
                            src="../../assets/img/jddetails/nosearchmatch.svg"
                            alt=""
                          />
                          <div class="no-match mt-3">
                            No matching results for
                            <span class="searchtext wordbreak"
                              >"{{ searchname }}"
                            </span>
                          </div>
                        </div>
                        <div
                          v-else-if="
                            saveAllCandidate == '' || saveAllCandidate == null
                          "
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            mt-3
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                        >
                          <div>
                            <img src="../../assets/emptyjdillust.svg" alt="" />
                          </div>
                          <div
                            v-if="
                              (sourceof != '' &&
                                saveAllCandidate.length == 0) ||
                              (areaofexp != '' &&
                                saveAllCandidate.length == 0) ||
                              (assessmentStatus != '' &&
                                saveAllCandidate.length == 0)
                            "
                          >
                            <span>No Data </span>
                          </div>
                          <div v-else-if="saveAllCandidate.length == 0">
                            <span class="searchnotfound">
                              There are no
                              <strong>'ON-HOLD' </strong>
                              candidates</span
                            >
                          </div>
                        </div>
                        <tbody v-else>
                          <tr
                            class="selected-table-cards"
                            v-for="(Details, index) in saveAllCandidate"
                            :key="index"
                          >
                            <td class="text-center" style="width: 7%">
                              <div
                                v-once
                                class="gridgreencolorDynamic mr-1"
                              ></div>
                              <img
                                v-if="
                                  Details.source == 'other' ||
                                  Details.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </td>

                            <td style="width: 25%" class="text-center">
                              {{ Details.name }}
                            </td>
                            <td style="width: 20%" class="text-center">
                              {{ Details.email }}
                            </td>

                            <td style="width: 20%" class="text-center">
                              <span
                                :id="'tp4' + Details.candidateID"
                                class="defaultCursor"
                                >{{ Details.skills | fnName }}</span
                              >
                              <span>
                                <b-popover
                                  :target="'tp4' + Details.candidateID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="skill in Details.skills"
                                    :key="skill.id"
                                  >
                                    {{ skill }}
                                    <span
                                      v-if="index != Details.skills.length - 1"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </td>

                            <td style="width: 15%" class="text-center">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                  text-center
                                "
                              >
                                <div class="d-flex align-items-center">
                                  <div
                                    class="pointer"
                                    v-b-popover.hover.top="'Feedback History'"
                                    @click="history(Details)"
                                    v-if="
                                      Details.kanbanLevel != 0 &&
                                      Details.kanbanLevel != 1
                                    "
                                  >
                                    <img
                                      src="../../assets/img/jddetails/viewhisticon.svg"
                                      alt=""
                                    />
                                  </div>

                                  <img
                                    v-if="Details.awaitingForApproval == null"
                                    v-b-popover.hover.top="'Action'"
                                    @click="
                                      (!Details.selectionInfo &&
                                        Details.kanbanLevel === 'NI') ||
                                      (!Details.selectionInfo &&
                                        Details.kanbanLevel === 'R')
                                        ? rejectConfirmModal(Details)
                                        : !Details.selectionInfo
                                        ? openGiveFeedbackModal(Details)
                                        : openFinalAction(Details)
                                    "
                                    src="../../assets/img/jddetails/Action.svg"
                                    class="ml-3 pointer"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    src="../../assets/img/jddetails/dash.svg"
                                    class="ml-3"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </td>
                            <td style="width: 13%" class="text-center">
                              <div
                                class="d-flex align-items-center text-center"
                              >
                                <b-button variant="outline">
                                  <img
                                    @click="downloadResume(Details.resume)"
                                    v-b-popover.hover.top="'Download'"
                                    src="../../assets/img/jddetails/download-jddetail.svg"
                                    alt=""
                                  />
                                </b-button>

                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(Details)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  class="ml-2 pointer"
                                  alt=""
                                />

                                <img
                                  v-if="
                                    Details.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  v-b-popover.hover.top="'View'"
                                  @click="viewCandidate(Details)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Rejected" @click="switchTabs('R')">
                  <div>
                    <!-- table starts -->
                    <div class="table-main">
                      <table
                        :aria-describedby="'Rejected'"
                        class="
                          w-100
                          tp-reports-table
                          selected-dash-table
                          jdtablecontent
                        "
                      >
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 7%">
                              <span class="mr-1">Source</span>
                              <template v-if="statusValue == 'source'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('source', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('source', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 25%" class="text-center">
                              <span class="mr-1">Candidate Name</span>
                              <template v-if="statusValue == 'name'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('name', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('name', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>
                            <th style="width: 20%" class="text-center">
                              <span>Email ID</span>
                              <template v-if="statusValue == 'email'">
                                <img
                                  v-if="sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', false)"
                                  src="../../assets/img/candidatedashboard/upfilter.svg"
                                  alt=""
                                />
                                <img
                                  v-if="!sortByValue && filter"
                                  class="pointer"
                                  @click="filterCandidates('email', true)"
                                  src="../../assets/img/candidatedashboard/downfilter.svg"
                                  alt=""
                                />
                              </template>
                              <img
                                class="pointer"
                                v-else
                                @click="filterCandidates('email', true)"
                                src="../../assets/img/candidatedashboard/nofilter.svg"
                                alt=""
                              />
                            </th>

                            <th style="width: 20%" class="text-center">
                              <span>Skills</span>
                            </th>

                            <th style="width: 15%" class="text-center">
                              <span>Actions</span>
                            </th>
                            <th class="text-center" style="width: 13%">
                              <span>Options</span>
                            </th>
                          </tr>
                        </thead>
                        <div
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                          v-if="
                            searchname !== '' && saveAllCandidate.length === 0
                          "
                        >
                          <img
                            src="../../assets/img/jddetails/nosearchmatch.svg"
                            alt=""
                          />
                          <div class="no-match mt-3">
                            No matching results for
                            <span class="searchtext wordbreak"
                              >"{{ searchname }}"
                            </span>
                          </div>
                        </div>
                        <div
                          v-else-if="
                            saveAllCandidate == '' || saveAllCandidate == null
                          "
                          class="
                            d-flex
                            flex-column
                            align-items-center
                            mt-3
                            justify-content-center
                          "
                          style="height: calc(100vh - 370px)"
                        >
                          <div>
                            <img src="../../assets/emptyjdillust.svg" alt="" />
                          </div>
                          <div
                            v-if="
                              (sourceof != '' &&
                                saveAllCandidate.length == 0) ||
                              (areaofexp != '' &&
                                saveAllCandidate.length == 0) ||
                              (assessmentStatus != '' &&
                                saveAllCandidate.length == 0)
                            "
                          >
                            <span>No Data </span>
                          </div>
                          <div v-else-if="saveAllCandidate.length == 0">
                            <span class="searchnotfound">
                              There are no
                              <strong>'Rejected' </strong> candidates</span
                            >
                          </div>
                        </div>
                        <tbody v-else>
                          <tr
                            class="selected-table-cards"
                            v-for="(Details, index) in saveAllCandidate"
                            :key="index"
                          >
                            <td class="text-center" style="width: 7%">
                              <div
                                v-once
                                class="gridgreencolorDynamic mr-1"
                              ></div>
                              <img
                                v-if="
                                  Details.source == 'other' ||
                                  Details.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="Details.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </td>

                            <td style="width: 25%" class="text-center">
                              {{ Details.name }}
                            </td>
                            <td style="width: 20%" class="text-center">
                              {{ Details.email }}
                            </td>

                            <td style="width: 20%" class="text-center">
                              <span
                                :id="'tp5' + Details.candidateID"
                                class="defaultCursor"
                                >{{ Details.skills | fnName }}</span
                              >
                              <span>
                                <b-popover
                                  :target="'tp5' + Details.candidateID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="skill in Details.skills"
                                    :key="skill.id"
                                  >
                                    {{ skill }}
                                    <span
                                      v-if="index != Details.skills.length - 1"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </td>

                            <td style="width: 15%" class="text-center">
                              <div
                                class="
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                "
                              >
                                <div
                                  v-if="
                                    Details.type == 'assesment' &&
                                    Details.documentStatus != null &&
                                    !Details.documentStatus
                                  "
                                  v-b-popover.hover.top="
                                    'Documents Not Uploaded'
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/retriggerassessmentdisabled.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-else-if="
                                    Details.type == 'assesment' &&
                                    Details.kanbanScheduled == true
                                  "
                                >
                                  <img
                                    src="../../assets/img/jddetails/asmntdoneicon.svg"
                                    alt=""
                                  />
                                </div>
                                <div
                                  v-if="
                                    Details.type == 'assesment' &&
                                    Details.kanbanScheduled == false &&
                                    Details.documentStatus != null &&
                                    Details.documentStatus == true
                                  "
                                  class="ml-2"
                                  v-b-popover.hover.top="'Action'"
                                  @click="rejectConfirmModal(Details)"
                                >
                                  <img
                                    src="../../assets/img/jddetails/Action.svg"
                                    alt=""
                                  />
                                </div>
                                <div class="d-flex align-items-center ml-3">
                                  <div
                                    v-b-popover.hover.top="'Feedback History'"
                                    v-if="
                                      Details.kanbanLevel != 0 &&
                                      Details.kanbanLevel != 1
                                    "
                                    @click="history(Details)"
                                  >
                                    <img
                                      src="../../assets/img/jddetails/viewhisticon.svg"
                                      alt=""
                                      class="pointer"
                                    />
                                  </div>
                                  <img
                                    v-if="
                                      Details.type == 'f2f' &&
                                      Details.documentStatus != null &&
                                      !Details.documentStatus
                                    "
                                    v-b-popover.hover.top="
                                      'Documents Not Uploaded'
                                    "
                                    class="ml-3"
                                    src="../../assets/img/jddetails/reschedicondisabled.svg"
                                    alt=""
                                  />
                                  <img
                                    v-else-if="
                                      Details.kanbanLevel == 'R' &&
                                      Details.kanbanScheduled == false &&
                                      Details.kanbanLevel != 'F' &&
                                      Details.kanbanLevel != 'H' &&
                                      (Details.documentStatus == null ||
                                        (Details.documentStatus != null &&
                                          Details.documentStatus == true))
                                    "
                                    v-b-popover.hover.top="'Action'"
                                    @click="rejectConfirmModal(Details)"
                                    class="ml-3 pointer"
                                    src="../../assets/img/jddetails/Action.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </td>
                            <td style="width: 13%" class="text-center">
                              <div
                                class="d-flex align-items-center text-center"
                              >
                                <b-button variant="outline">
                                  <img
                                    @click="downloadResume(Details.resume)"
                                    v-b-popover.hover.top="'Download'"
                                    src="../../assets/img/jddetails/download-jddetail.svg"
                                    alt=""
                                  />
                                </b-button>

                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(Details)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  class="ml-2 pointer"
                                  alt=""
                                />

                                <img
                                  v-if="
                                    Details.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  v-b-popover.hover.top="'View'"
                                  @click="viewCandidate(Details)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  class="ml-3 pointer"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              <div
                class="
                  paginaTion
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <div class="qb-gotopage-text p-1">Go to page</div>
                  <b-form-input
                    type="text"
                    class="qb-pagination-num mr-1"
                    v-model="goToPage"
                    @keyup.enter="gotopgnum()"
                    @keypress="NumbersOnly"
                  >
                  </b-form-input>
                  <b-button
                    @click="gotopgnum"
                    class="qb-pagination-addbtn"
                    :disabled="
                      goToPage === null || goToPage == '' || iscontainsNumber
                    "
                  >
                    <span>
                      <img src="../../assets/whiterightarrow.svg" alt="" />
                    </span>
                  </b-button>
                </div>

                <div class="pagination">
                  <b-pagination
                    v-model="currentPage"
                    @input="getJobDetails(), (goToPage = null)"
                    :total-rows="total"
                    :per-page="perPageCount"
                    align="center"
                    first-number
                    last-number
                  >
                    <template #prev-text>
                      <span>
                        <img src="../../assets/leftvector.svg" alt="" />
                      </span>
                    </template>
                    <template #next-text>
                      <span>
                        <img src="../../assets/rightarrow.svg" alt="" />
                      </span>
                    </template>
                  </b-pagination>
                </div>

                <div class="qb-gotopage-text mr-2">
                  Results : <span v-if="pageStart > total">0</span
                  ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                  <span class="pl-1"></span> of <span class="pr-1"></span
                  >{{ total }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  Table for Add Candidate Popup -->
    <b-modal
      id="modal-center"
      size="xl"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      :no-close-on-backdrop="true"
    >
      <b-overlay :show="showSpinner" rounded="sm">
        <div
          class="
            page-heading
            d-flex
            justify-content-between
            align-items-center
            p-2
          "
        >
          <div class="jd-modal-heading">
            <span>List Of Candidates</span>
          </div>
        </div>
        <div
          @click="closeCandidateModal()"
          class="xMarkCancel"
          style="top: -25px; right: -25px"
        >
          <img src="../../assets/cross-round.svg" alt="" />
        </div>
        <div class="jd-modal-table-container">
          <div class="d-flex align-items-center justify-content-between">
            <div class="search-bar-popup mr-3">
              <img
                class="searchicon"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />
              <b-form-input
                type="search"
                class="search-input"
                placeholder="Search Candidates"
                debounce="500"
                v-model="searchPopUpCandidates"
                @update="searchTalentPool"
              ></b-form-input>
            </div>
            <div>
              <b-button
                :disabled="isEmpty"
                @click="addtojd"
                class="addbtn d-flex align-items-center"
              >
                <img
                  src="../../assets/Group (6).svg"
                  alt=""
                  class="mr-2 mb-1"
                />

                <span class="">Add to JD</span>
              </b-button>
            </div>
            <div>
              <div class="d-flex switchtext pointer relativeclass">
                <div>
                  <b-button class="addbtn" @click="goToCanditatePage()">
                    <img
                      src="../../assets/Group (6).svg"
                      alt=""
                      class="mr-2 mb-1"
                    />

                    <span class="">Add New Candidate</span>
                  </b-button>
                </div>
                <div
                  class="relativeclass"
                  ref="close-filter"
                  v-closable="{
                    exclude: ['close-filter', 'select-filter'],
                    handler: 'closeTalentPoolFilter',
                  }"
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-center
                      mt-1
                    "
                  >
                    <img
                      class="ml-4"
                      v-b-popover.hover.bottom="'Filter'"
                      src="../../assets/img/talentpool/filtericon.svg"
                      alt=""
                      @click="PopupShowfiltercard = !PopupShowfiltercard"
                    />

                    <div
                      class="addTP-filter-count mb-3"
                      v-if="addTPfiltercount != 0"
                    >
                      {{ addTPfiltercount }}
                    </div>
                  </div>
                  <div v-if="PopupShowfiltercard">
                    <div class="panelist-filtercard d-flex align-items-center">
                      <div>
                        <div
                          @click="PopupShowfiltercard = false"
                          class="xMarkCancel pointer"
                        >
                          <img src="../../assets/xmark.svg" alt="" />
                        </div>
                        <b-row>
                          <b-col>
                            <div class="topDiv mt-3">
                              <label class="fieldsetStyle sharelabel"
                                >Source</label
                              >
                              <div
                                ref="close-source"
                                v-closable="{
                                  exclude: ['close-source', 'select-source'],
                                  handler: 'filtercloseSource',
                                }"
                              >
                                <div
                                  class="
                                    pl-dropdown-diffy
                                    d-flex
                                    justify-content-between
                                    pointer
                                  "
                                  @click="
                                    PopupDbfilterdrop = !PopupDbfilterdrop
                                  "
                                >
                                  <span v-if="PopupSourceof == ''"
                                    >Choose options</span
                                  ><span v-else>{{ PopupSourceof }}</span>
                                  <span
                                    ><img
                                      v-if="!PopupDbfilterdrop"
                                      src="../../assets/rec-main-downArrow.svg"
                                      alt=""
                                      class="mr-1"
                                    />
                                    <img
                                      v-else
                                      src="../../assets/rec-main-upArrow.svg"
                                      alt=""
                                      class="mr-1"
                                    />
                                  </span>
                                </div>

                                <div
                                  v-if="PopupDbfilterdrop"
                                  class="pl-dropdown-option-add d-flex"
                                >
                                  <b-form-group
                                    class="pl-dd-group"
                                    v-slot="{ ariaDescribedby }"
                                  >
                                    <b-form-radio-group
                                      @change="
                                        PopupDbfilterdrop = !PopupDbfilterdrop
                                      "
                                      class="pl-add-drop w-100"
                                      id="btn-radios-3"
                                      v-model="PopupSourceof"
                                      :options="PopupSource_options"
                                      :aria-describedby="ariaDescribedby"
                                      name="radio-btn-stacked"
                                      disabled-field="notEnabled"
                                      buttons
                                      stacked
                                    >
                                    </b-form-radio-group>
                                  </b-form-group>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <div class="topDiv mt-3" @click.stop="">
                              <label class="fieldsetStyle">Skills &nbsp;</label>
                              <b-form-tags
                                class="jd-filterinputField"
                                id="input-1"
                                placeholder="Enter Skills"
                                v-model="PopupAreaofexp"
                                type="text"
                                invalid-tag-text="Duplicate tag(s)"
                                remove-on-delete
                              ></b-form-tags>
                            </div>
                          </b-col>
                        </b-row>
                        <div class="d-flex justify-content-between mt-3">
                          <div
                            class="clearfilter pointer"
                            :class="
                              PopupSourceof == '' &&
                              PopupAreaofexp.length == 0 &&
                              addTPfiltercount == 0
                                ? 'disabled-text'
                                : 'pointer'
                            "
                            @click="
                              PopupSourceof == '' &&
                              PopupAreaofexp.length == 0 &&
                              addTPfiltercount == 0
                                ? ''
                                : PopupClearfilter()
                            "
                          >
                            Clear Filter
                          </div>
                          <div>
                            <b-button
                              :disabled="
                                PopupSourceof == '' &&
                                PopupAreaofexp.length == 0
                              "
                              class="addbtn"
                              @click="applyFilterTest()"
                            >
                              Apply
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- table starts -->
          <div class="sendmultiasmnt">
            <div class="tabbed mt-3">
              <b-tabs class="">
                <b-tab title="Active Candidates" @click="switchPopUpTabs('1')">
                  <div class="table-main">
                    <table
                      :aria-describedby="'Active Candidates'"
                      class="w-100 tp-reports-table"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 50px">
                            <span>
                              <b-form-checkbox
                                v-if="candidateTalentPool.length !== 0"
                                v-model="allSelected"
                                @change="selectAll()"
                              >
                              </b-form-checkbox
                            ></span>
                          </th>
                          <th class="text-center" style="width: 150px">
                            <span class="mr-1">Source</span>
                            <template v-if="PopupStatusValue == 'source'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('source', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('source', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('source', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center">
                            <span class="mr-1">Candidate Name</span>
                            <template v-if="PopupStatusValue == 'name'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('name', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('name', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('name', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center">
                            <span>Email ID</span>
                            <template v-if="PopupStatusValue == 'email'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('email', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('email', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('email', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center"><span>Skills</span></th>
                          <th class="text-center" style="width: 165px">
                            <span>Status</span>
                          </th>
                          <th class="text-center" style="width: 15%">
                            <span>Actions</span>
                          </th>
                        </tr>
                      </thead>

                      <tbody v-if="PopUptype == '1'">
                        <tr
                          v-for="(cand, index) in candidateTalentPool"
                          :key="index"
                        >
                          <td class="text-center" style="width: 50px">
                            <span class="color-bar"></span>
                            <span>
                              <b-form-checkbox
                                v-model="jdSelectCand"
                                :value="cand.candidateID"
                                @change="deselect()"
                                :disabled="!cand.resume || cand.resume == null"
                              >
                              </b-form-checkbox>
                            </span>
                          </td>
                          <td class="text-center" style="width: 150px">
                            <span>
                              <img
                                v-if="
                                  cand.source == 'other' || cand.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </span>
                          </td>
                          <td class="text-center">
                            <span>{{ cand.name }}</span>
                          </td>
                          <td class="text-center">
                            <span>{{ cand.email }}</span>
                          </td>
                          <td class="text-center">
                            <span
                              :id="'tp6' + cand.candidateID"
                              class="defaultCursor"
                              >{{ cand.skills | fnName }}</span
                            >
                            <span>
                              <b-popover
                                :target="'tp6' + cand.candidateID"
                                triggers="hover"
                                placement="top"
                              >
                                <span
                                  v-for="(skill, index) in cand.skills"
                                  :key="skill.id"
                                  >{{ skill }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                              </b-popover>
                            </span>
                          </td>
                          <td class="text-center" style="width: 145px">
                            <span
                              :class="{
                                activetext: cand.active,
                                Inactivetext: !cand.active,
                              }"
                              >{{ cand.active ? "Active" : "Inactive" }}</span
                            >
                          </td>
                          <td style="width: 15%" class="text-center">
                            <ul
                              class="
                                d-flex
                                p-0
                                m-0
                                justify-content-center
                                align-items-center
                                list-unstyled
                                text-center
                              "
                            >
                              <li>
                                <img
                                  v-if="cand.resume != null"
                                  @click="downloadasmntresume(cand.resume)"
                                  v-b-popover.hover.top="'Download'"
                                  class="pointer"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else-if="
                                    cand.resume == null || !cand.resume
                                  "
                                  style="opacity: 50%"
                                  class="jd-no-download"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(cand)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  alt=""
                                  class="pointer ml-3 mr-3"
                                />
                              </li>
                              <li>
                                <img
                                  v-b-popover.hover.top="'View'"
                                  class="pointer"
                                  @click="viewCandidate(cand)"
                                  v-if="
                                    cand.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                />
                              </li>
                            </ul>
                          </td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-if="
                            (candidateTalentPool.length === 0 &&
                              PopupSourceof != '') ||
                            (candidateTalentPool.length === 0 &&
                              PopupAreaofexp != '')
                          "
                        >
                          <td>No Data</td>
                        </tr>

                        <tr
                          style="text-align: center"
                          v-else-if="
                            searchPopUpCandidates != '' &&
                            candidateTalentPool.length == 0
                          "
                        >
                          <td>
                            No matching results found for "{{
                              searchPopUpCandidates
                            }}"
                          </td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="candidateTalentPool.length == 0"
                        >
                          <td>No Records Found</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- table ends -->
                </b-tab>

                <b-tab
                  title="Inactive Candidates"
                  @click="switchPopUpTabs('0')"
                >
                  <div class="table-main">
                    <table
                      :aria-describedby="'Inactive Candidates'"
                      class="w-100 tp-reports-table"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 50px">
                            <span>
                              <b-form-checkbox
                                v-if="candidateTalentPool.length !== 0"
                                v-model="allSelected"
                                @change="selectAll()"
                              >
                              </b-form-checkbox
                            ></span>
                          </th>
                          <th class="text-center" style="width: 150px">
                            <span class="mr-1">Source</span>
                            <template v-if="PopupStatusValue == 'source'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('source', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('source', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('source', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center">
                            <span class="mr-1">Candidate Name</span>
                            <template v-if="PopupStatusValue == 'name'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('name', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('name', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('name', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center">
                            <span>Email ID</span>
                            <template v-if="PopupStatusValue == 'email'">
                              <img
                                v-if="PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('email', false)"
                                src="../../assets/img/candidatedashboard/upfilter.svg"
                                alt=""
                              />
                              <img
                                v-if="!PopupSortByValue && filter"
                                class="pointer"
                                @click="filterTalentPool('email', true)"
                                src="../../assets/img/candidatedashboard/downfilter.svg"
                                alt=""
                              />
                            </template>
                            <img
                              class="pointer"
                              v-else
                              @click="filterTalentPool('email', true)"
                              src="../../assets/img/candidatedashboard/nofilter.svg"
                              alt=""
                            />
                          </th>
                          <th class="text-center"><span>Skills</span></th>
                          <th class="text-center" style="width: 165px">
                            <span>Status</span>
                          </th>
                          <th class="text-center" style="width: 15%">
                            <span>Actions</span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(cand, index) in candidateTalentPool"
                          :key="index"
                        >
                          <td class="text-center" style="width: 50px">
                            <span class="color-bar"></span>
                            <span>
                              <b-form-checkbox
                                v-model="jdSelectCand"
                                :value="cand.candidateID"
                                @change="deselect()"
                                :disabled="!cand.resume || cand.resume == null"
                              >
                              </b-form-checkbox>
                            </span>
                          </td>
                          <td class="text-center" style="width: 150px">
                            <span>
                              <img
                                v-if="
                                  cand.source == 'other' || cand.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </span>
                          </td>
                          <td class="text-center">
                            <span>{{ cand.name }}</span>
                          </td>
                          <td class="text-center">
                            <span>{{ cand.email }}</span>
                          </td>
                          <td class="text-center">
                            <span
                              :id="'tp7' + cand.candidateID"
                              class="defaultCursor"
                              >{{ cand.skills | fnName }}</span
                            >
                            <span>
                              <b-popover
                                :target="'tp7' + cand.candidateID"
                                triggers="hover"
                                placement="top"
                              >
                                <span
                                  v-for="(skill, index) in cand.skills"
                                  :key="skill.id"
                                  >{{ skill }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                              </b-popover>
                            </span>
                          </td>
                          <td class="text-center" style="width: 145px">
                            <span
                              :class="{
                                activetext: cand.active,
                                Inactivetext: !cand.active,
                              }"
                              >{{ cand.active ? "Active" : "Inactive" }}</span
                            >
                          </td>

                          <td style="width: 15%" class="text-center">
                            <ul
                              class="
                                d-flex
                                p-0
                                m-0
                                justify-content-center
                                align-items-center
                                list-unstyled
                                text-center
                              "
                            >
                              <li>
                                <img
                                  v-if="cand.resume != null"
                                  @click="downloadasmntresume(cand.resume)"
                                  v-b-popover.hover.top="'Download'"
                                  class="pointer"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else-if="
                                    cand.resume == null || !cand.resume
                                  "
                                  style="opacity: 50%"
                                  class="jd-no-download"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                              </li>

                              <li>
                                <img
                                  class="ml-3 mr-3"
                                  style="opacity: 50%"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li @click="viewCandidate(cand)">
                                <img
                                  v-b-popover.hover.top="'View'"
                                  class="pointer"
                                  v-if="
                                    cand.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                />
                              </li>
                            </ul>
                          </td>
                        </tr>

                        <tr
                          style="text-align: center"
                          v-if="
                            (candidateTalentPool.length === 0 &&
                              PopupSourceof != '') ||
                            (candidateTalentPool.length === 0 &&
                              PopupAreaofexp != '')
                          "
                        >
                          <td>No Data</td>
                        </tr>

                        <tr
                          style="text-align: center"
                          v-else-if="
                            searchPopUpCandidates != '' &&
                            candidateTalentPool.length == 0
                          "
                        >
                          <td>
                            No matching results found for "{{
                              searchPopUpCandidates
                            }}"
                          </td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="candidateTalentPool.length == 0"
                        >
                          <td>No Records Found</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- table ends -->
                </b-tab>
              </b-tabs>
              <div
                class="
                  paginaTion
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <span class="qb-gotopage-text p-1">Go to page</span>
                  <b-form-input
                    type="text"
                    class="qb-pagination-num mr-1"
                    v-model="PopupGoToPage"
                    @keyup.enter="
                      PopupGoToPage === null ||
                      PopupGoToPage == '' ||
                      iscontainsNumberPopup
                        ? ''
                        : PopupGotopgnum(PopupGoToPage),
                        (allSelected = false),
                        (jdSelectCand = [])
                    "
                    @keypress="NumbersOnly"
                  ></b-form-input>
                  <b-button
                    class="qb-pagination-addbtn"
                    @click="
                      PopupGotopgnum(PopupGoToPage),
                        (allSelected = false),
                        (jdSelectCand = [])
                    "
                    :disabled="
                      PopupGoToPage === null ||
                      PopupGoToPage == '' ||
                      iscontainsNumberPopup
                    "
                  >
                    <span
                      ><img src="../../assets/whiterightarrow.svg" alt=""
                    /></span>
                  </b-button>
                </div>
                <div class="pagination">
                  <b-pagination
                    v-model="PopupCurrentPage"
                    @input="showAllCandidates(), (PopupGoToPage = null)"
                    :total-rows="PopupTotal"
                    :per-page="PopupPagecount"
                    align="center"
                    first-number
                    last-number
                  >
                    <template #prev-text
                      ><span
                        ><img src="../../assets/leftvector.svg" alt="" /> </span
                    ></template>
                    <template #next-text
                      ><span
                        ><img src="../../assets/rightarrow.svg" alt="" /></span
                    ></template>
                  </b-pagination>
                </div>
                <div class="qb-gotopage-text mr-2">
                  Results :
                  <span v-if="PopupPageStart > PopupTotal">0</span
                  ><span v-else>{{ PopupPageStart }}</span> -
                  {{ PopupPageEnd }} <span class="pl-1"></span> of
                  <span class="pr-1"></span>{{ PopupTotal }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>

    <!--  Table for Send Assessment Candidate Popup -->
    <b-modal
      id="sendmultiasessmodal"
      size="xl"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      :no-close-on-backdrop="true"
    >
      <div
        class="
          page-heading
          d-flex
          justify-content-between
          align-items-center
          p-2
        "
      >
        <div class="jd-modal-heading">
          <span>List Of Candidates</span>
        </div>
      </div>
      <div @click="$bvModal.hide('sendmultiasessmodal')" class="xMarkCancel">
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div class="jd-modal-table-container">
        <div class="d-flex align-items-center justify-content-between">
          <div class="search-bar-popup mr-3">
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
            <b-form-input
              type="search"
              class="search-input"
              placeholder="Search Candidates"
              v-model.trim="searchSendCandidates"
              @keyup="handleKeyUp"
              @keydown="handleKeyPress"
            ></b-form-input>
          </div>

          <div>
            <div class="d-flex switchtext pointer relativeclass">
              <div>
                <b-button
                  class="addbtn"
                  :disabled="sendmultiselected.length == 0"
                  @click="$bvModal.show('confirmmultiplesend')"
                >
                  <span v-if="assessmentScheduleType == 'false'"
                    >Trigger Assessment
                  </span>
                  <span v-else>Retrigger Assessment </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <!-- table starts -->
        <div class="sendmultiasmnt">
          <div class="tabbed mt-3 mb-0">
            <b-tabs class="">
              <b-tab
                title="Trigger Assessment"
                @click="clearMultiAssessFields('false')"
              >
                <div class="table-main">
                  <table
                    :aria-describedby="'Trigger Assessment'"
                    class="w-100 tp-reports-table sndmultiasmnt-table"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 5%">
                          <span v-if="multisendcandidates.length != 0">
                            <b-form-checkbox
                              v-model="sendallmulti"
                              @change="selectAllMulti"
                              :disabled="
                                noCandWithDocs || isConfigExpiredForAll
                              "
                            >
                            </b-form-checkbox>
                          </span>
                        </th>
                        <th class="text-start" style="width: 7%">
                          <span>Source</span>
                        </th>
                        <th style="width: 18%" class="text-center">
                          <span>Candidate Name</span>
                        </th>
                        <th style="width: 20%" class="text-center">
                          <span>Email ID</span>
                        </th>
                        <th style="width: 20%" class="text-center">
                          <span>Skills</span>
                        </th>
                        <th style="width: 15%" class="text-center">Round</th>
                        <th class="text-center" style="width: 15%">
                          <span>Actions</span>
                        </th>
                      </tr>
                    </thead>
                    <b-overlay :show="multiAssessSpinner">
                      <tbody>
                        <tr
                          v-for="(cand, index) in multisendcandidates"
                          :key="index"
                        >
                          <td class="text-center" style="width: 5%">
                            <span class="color-bar"></span>
                            <span>
                              <b-form-checkbox
                                v-model="sendmultiselected"
                                :value="{
                                  candidateID: cand.candidateID,
                                  kanbanLevel: cand.kanbanLevel,
                                }"
                                @change="deselectmulti()"
                                :disabled="
                                  (cand.documentStatus !== 1 &&
                                    cand.documentStatus !== null) ||
                                  cand.isConfigExpired == true
                                "
                                :id="cand.candidateID"
                              >
                              </b-form-checkbox>
                            </span>
                          </td>
                          <td class="pl-2" style="width: 7%">
                            <span>
                              <img
                                v-if="
                                  cand.source == 'other' || cand.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </span>
                          </td>
                          <td class="text-center" style="width: 18%">
                            <span>{{ cand.name }}</span>
                          </td>
                          <td class="text-center" style="width: 20%">
                            <span>{{ cand.email }}</span>
                          </td>
                          <td class="text-center" style="width: 20%">
                            <span
                              :id="'tp8' + cand.candidateID"
                              class="defaultCursor"
                              >{{ cand.skills | fnName }}</span
                            >
                            <span>
                              <b-popover
                                :target="'tp8' + cand.candidateID"
                                triggers="hover"
                                placement="top"
                              >
                                <span
                                  v-for="(skill, index) in cand.skills"
                                  :key="skill.id"
                                  >{{ skill }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                              </b-popover>
                            </span>
                          </td>
                          <td style="width: 15%" class="text-center">
                            <div
                              v-if="cand.documentStatus == 0"
                              class="align-items-center"
                            >
                              <img src="../../assets/rejecteddoc.svg" alt="" />
                              <span class="redDoc ml-1"
                                >Documents Rejected</span
                              >
                            </div>
                            <div
                              v-else-if="
                                cand.documentStatus == 4 ||
                                cand.documentStatus == 2
                              "
                              @click="viewRequiredDocs(cand.candidateID)"
                              class="pointer"
                            >
                              <img
                                src="../../assets/viewdocuments.svg"
                                alt=""
                              />
                              <span class="greenDoc ml-2">View Documents</span>
                            </div>
                            <div
                              v-else-if="cand.documentStatus == 3"
                              class="defaultCursor"
                            >
                              <img src="../../assets/requesteddoc.svg" alt="" />
                              <span class="yellowDoc">Documents Requested</span>
                            </div>
                            <div
                              v-else
                              class="text-center"
                              :class="roundClass(cand.kanbanLevel)"
                            >
                              Round {{ cand.kanbanLevel }}
                            </div>
                          </td>
                          <td
                            style="width: 15%"
                            class="multiasmnt-tab-atag text-center"
                          >
                            <ul
                              class="
                                d-flex
                                p-0
                                m-0
                                justify-content-center
                                align-items-center
                                list-unstyled
                                text-center
                              "
                            >
                              <li>
                                <img
                                  v-b-popover.hover.top="'Download'"
                                  @click="downloadasmntresume(cand.resume)"
                                  class="pointer"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  class="pointer ml-3 mr-3"
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(cand)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li
                                v-b-popover.hover.top="'View'"
                                @click="viewCandidate(cand)"
                              >
                                <img
                                  v-b-popover.hover.top="'View'"
                                  v-if="
                                    cand.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  @click="viewCandidate(cand)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </li>
                            </ul>
                          </td>
                        </tr>

                        <tr
                          style="text-align: center"
                          v-if="
                            PopupSourceof != '' &&
                            multisendcandidates.length == 0 &&
                            !multiAssessSpinner
                          "
                        >
                          <td>No Data</td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="
                            multisendcandidates.length == 0 &&
                            !multiAssessSpinner &&
                            searchSendCandidates != ''
                          "
                        >
                          <td>
                            No matching results for "{{ searchSendCandidates }}"
                          </td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="
                            multisendcandidates.length === 0 &&
                            !multiAssessSpinner
                          "
                        >
                          <td>No Records Found</td>
                        </tr>
                      </tbody>
                    </b-overlay>
                  </table>
                </div>
              </b-tab>
              <b-tab
                title="Retrigger Assessment"
                @click="clearMultiAssessFields('true')"
              >
                <div class="table-main">
                  <table
                    :aria-describedby="'Retrigger Assessment'"
                    class="w-100 tp-reports-table sndmultiasmnt-table"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" style="width: 5%">
                          <span v-if="multisendcandidates.length != 0">
                            <b-form-checkbox
                              v-model="sendallmulti"
                              @change="selectAllMulti"
                              :disabled="isConfigExpiredForAll"
                            >
                            </b-form-checkbox>
                          </span>
                        </th>
                        <th class="text-start" style="width: 7%">
                          <span>Source</span>
                        </th>
                        <th style="width: 18%" class="text-center">
                          <span>Candidate Name</span>
                        </th>
                        <th style="width: 20%" class="text-center">
                          <span>Email ID</span>
                        </th>
                        <th style="width: 20%" class="text-center">
                          <span>Skills</span>
                        </th>
                        <th style="width: 15%" class="text-center">Round</th>

                        <th class="text-center" style="width: 15%">
                          <span>Actions</span>
                        </th>
                      </tr>
                    </thead>

                    <b-overlay :show="multiAssessSpinner">
                      <tbody>
                        <tr
                          v-for="(cand, index) in multisendcandidates"
                          :key="index"
                        >
                          <td class="text-center" style="width: 5%">
                            <span class="color-bar"></span>
                            <span>
                              <b-form-checkbox
                                v-model="sendmultiselected"
                                :value="{
                                  candidateID: cand.candidateID,
                                  kanbanLevel: cand.kanbanLevel,
                                }"
                                @change="deselectmulti()"
                                :disabled="cand.isConfigExpired == true"
                                :id="cand.candidateID"
                              >
                              </b-form-checkbox>
                            </span>
                          </td>
                          <td class="pl-2" style="width: 7%">
                            <span>
                              <img
                                v-if="
                                  cand.source == 'other' || cand.source == null
                                "
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'linkedin'"
                                src="../../assets/img/talentpool/linkdin.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'monster'"
                                src="../../assets/img/talentpool/monster.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'naukri'"
                                src="../../assets/img/talentpool/naukri.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'indeed'"
                                src="../../assets/img/talentpool/indeed.svg"
                                alt=""
                              />
                              <img
                                v-else-if="cand.source == 'vendor'"
                                src="../../assets/img/talentpool/vendor.svg"
                                alt=""
                              />
                            </span>
                          </td>
                          <td class="text-center" style="width: 18%">
                            <span>{{ cand.name }}</span>
                          </td>
                          <td class="text-center" style="width: 20%">
                            <span>{{ cand.email }}</span>
                          </td>
                          <td class="text-center" style="width: 20%">
                            <span
                              :id="'tp9' + cand.candidateID"
                              class="defaultCursor"
                              >{{ cand.skills | fnName }}</span
                            >
                            <span>
                              <b-popover
                                :target="'tp9' + cand.candidateID"
                                triggers="hover"
                                placement="top"
                              >
                                <span
                                  v-for="(skill, index) in cand.skills"
                                  :key="skill.id"
                                  >{{ skill }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                              </b-popover>
                            </span>
                          </td>
                          <td class="text-center" style="width: 15%">
                            <div
                              class="text-center"
                              :class="roundClass(cand.kanbanLevel)"
                            >
                              Round {{ cand.kanbanLevel }}
                            </div>
                          </td>

                          <td
                            style="width: 15%"
                            class="multiasmnt-tab-atag text-center"
                          >
                            <ul
                              class="
                                d-flex
                                p-0
                                m-0
                                justify-content-center
                                align-items-center
                                list-unstyled
                                text-center
                              "
                            >
                              <li>
                                <img
                                  v-b-popover.hover.top="'Download'"
                                  @click="downloadasmntresume(cand.resume)"
                                  class="pointer"
                                  src="../../assets/img/jddetails/download-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  class="pointer ml-3 mr-3"
                                  v-b-popover.hover.top="'Edit'"
                                  @click="editjdcandidate(cand)"
                                  src="../../assets/img/jddetails/edit-jddetail.svg"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  class="pointer"
                                  v-b-popover.hover.top="'View'"
                                  v-if="
                                    cand.candidateID !=
                                    selectedCandidate.candidateID
                                  "
                                  @click="viewCandidate(cand)"
                                  src="../../assets/img/jddetails/view-jddetail.svg"
                                  alt=""
                                />
                                <img
                                  v-else
                                  src="../../assets/img/jddetails/notview-jddetails.svg"
                                  alt=""
                                  class="ml-3"
                                />
                              </li>
                            </ul>
                          </td>
                        </tr>

                        <tr
                          style="text-align: center"
                          v-if="
                            PopupSourceof != '' &&
                            multisendcandidates.length == 0 &&
                            !multiAssessSpinner
                          "
                        >
                          <td>No Data</td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="
                            multisendcandidates.length == 0 &&
                            !multiAssessSpinner &&
                            searchSendCandidates != ''
                          "
                        >
                          <td>
                            No matching results for "{{ searchSendCandidates }}"
                          </td>
                        </tr>
                        <tr
                          style="text-align: center"
                          v-else-if="
                            multisendcandidates.length === 0 &&
                            !multiAssessSpinner
                          "
                        >
                          <td>No Records Found</td>
                        </tr>
                      </tbody>
                    </b-overlay>
                  </table>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <!-- table ends -->
        <div
          class="paginaTion d-flex justify-content-between align-items-center"
          v-if="multisendcandidates.length > 0"
        >
          <div class="d-flex">
            <div class="qb-gotopage-text p-1">Go to page</div>
            <b-form-input
              type="text"
              class="qb-pagination-num mr-1"
              v-model="PopupGoToPage"
              v-on:keyup.enter="jumpToPage(PopupGoToPage)"
              @keypress="NumbersOnly"
            ></b-form-input>

            <b-button
              @click="jumpToPage(PopupGoToPage)"
              class="qb-pagination-addbtn"
              :disabled="
                PopupGoToPage == null ||
                PopupGoToPage == '' ||
                iscontainsNumberPopup
              "
            >
              <span>
                <img src="../../assets/whiterightarrow.svg" alt="" />
              </span>
            </b-button>
          </div>
          <div class="pagination">
            <b-pagination
              v-model="multiCurrentPage"
              @input="getSendMultipleJob"
              :total-rows="multiTotal"
              :per-page="multiPerPageCount"
              align="center"
              first-number
              last-number
            >
              <template #prev-text>
                <span>
                  <img src="../../assets/leftvector.svg" alt="" />
                </span>
              </template>
              <template #next-text>
                <span>
                  <img src="../../assets/rightarrow.svg" alt="" />
                </span>
              </template>
            </b-pagination>
          </div>
          <div class="qb-gotopage-text mr-2">
            Results : <span v-if="multiPageStart > multiTotal">0</span
            ><span v-else>{{ multiPageStart }}</span> - {{ multiPageEnd }}
            <span class="pl-1"></span> of <span class="pr-1"></span
            >{{ multiTotal }}
          </div>
        </div>
      </div>
    </b-modal>

    <!-- ******************************** confirm multi adssessment trigger Start*****************-->
    <b-modal
      id="confirmmultiplesend"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      class="qb-add-ques-modal"
    >
      <b-overlay :show="showSpinner">
        <div
          class="modalheading d-flex align-items-center justify-content-between"
        >
          Caution !
        </div>
        <div
          v-show="!showSpinner"
          @click="$bvModal.hide('confirmmultiplesend')"
          class="xMarkCancel"
        >
          <img src="../../assets/xmark.svg" alt="" />
        </div>
        <hr />
        <div class="mt-3 testconfig-card-name">
          <span v-if="assessmentScheduleType == 'false'"
            >Are you sure you want to send Assessment to all the selected
            candidates.</span
          >
          <span v-else
            >Are you sure you want to re-trigger Assessment to all the selected
            candidates.</span
          >
        </div>
        <div class="mt-2 testconfig-card-name">
          <span class="asterik">*</span
          ><span>Please note this action cannot be undone</span>
        </div>
        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button class="addbtn mr-2" @click="sendToMutliple()"
            >Send</b-button
          >
          <div
            @click="$bvModal.hide('confirmmultiplesend')"
            class="cancelbtntext mr-2 pointer"
          >
            Cancel
          </div>
        </div>
      </b-overlay>
    </b-modal>
    <!-- ******************************** confirm multi adssessment trigger End *****************-->
    <b-modal
      id="SelOpsheadFinal"
      centered
      hide-footer
      hide-header
      class="p-0"
      no-close-on-backdrop
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Select Approver</span>
      </div>
      <div class="line-work">
        <hr />
        <div @click="closeSelOpshedFinalModal" class="xMarkCancel">
          <img src="../../assets/cross-round.svg" alt="" />
        </div>
      </div>
      <div class="jdd-rejectedsched-roundname-text">
        Please Select the Approver's Name for the Final Approval
      </div>
      <div class="topDiv mt-4 cipselectcolors">
        <label class="fieldsetStyle"
          >Approver&nbsp;<span class="asterik">*</span></label
        >
        <div
          @click="
            down = !down;
            getOpsHead();
          "
          class="
            d-flex
            align-items-center
            justify-content-between
            jdd-opshd-outline
          "
          :class="{ error: $v.select_opsHeadName.$error }"
        >
          <div
            class="d-flex align-items-center justify-content-between w-100"
            v-if="
              $v.select_opsHeadName.$dirty && !$v.select_opsHeadName.required
            "
          >
            <div class="folder-name" style="color: red">
              Please select an option
            </div>
            <div
              class="validationicon"
              v-if="$v.opsHeadRemarks.$dirty && !$v.opsHeadRemarks.required"
              v-b-popover.hover.top.v-danger="{
                content: 'Required',
              }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
          </div>
          <div
            v-else-if="!select_opsHeadName"
            class="d-flex align-items-center w-100"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="folder-name">Select</div>
              <div>
                <img src="../../assets/downarrow.svg" alt="" />
              </div>
            </div>
          </div>
          <div
            v-else
            class="
              d-flex
              align-items-center
              justify-content-between
              w-100
              folder-name
            "
          >
            {{ select_opsHeadName }}
            <div>
              <img src="../../assets/downarrow.svg" alt="" />
            </div>
          </div>
        </div>
        <div v-if="down" class="jdd-drop-ops w-100 pl-2 pr-2 pb-2">
          <div
            class="d-flex"
            style="border-bottom: 1px solid rgba(10, 86, 200, 0.5)"
          >
            <span>
              <img
                style="margin-top: 13px"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />
            </span>
            <b-form-input
              v-model.trim="searchQuery"
              @update="getOpsHead"
              debounce="500"
              type="search"
              placeholder="Search"
            ></b-form-input>
          </div>
          <div class="jdd-ops-overflow">
            <b-form-group v-if="opsHeadName.length > 0">
              <b-form-radio-group
                class="pl-add-drop w-100"
                @change="getApproverId"
                :options="opsHeadName"
                v-model="select_opsHeadName"
                buttons
                stacked
              ></b-form-radio-group>
            </b-form-group>
            <div
              v-else-if="opsHeadName.length == 0 && searchQuery.length > 0"
              class="mt-2 folder-name"
              size="sm"
            >
              No matching results for "{{ searchQuery }}".
            </div>
          </div>
        </div>
      </div>
      <div class="topDiv mt-4">
        <label class="fieldsetStyle"
          >Remarks&nbsp;<span class="asterik">*</span></label
        >
        <b-form-textarea
          rows="3"
          max-rows="4"
          class="jdd-inputField"
          type="text"
          placeholder="Enter remarks"
          v-model.trim="$v.opsHeadRemarks.$model"
          :class="{ error: $v.opsHeadRemarks.$error }"
          sendForApproval
        >
        </b-form-textarea>
        <div
          class="validationicon"
          v-if="$v.opsHeadRemarks.$dirty && !$v.opsHeadRemarks.required"
          v-b-popover.hover.top.v-danger="{
            content: 'Required',
          }"
        >
          <img src="../../assets/deletepopupicon.svg" alt="" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-5">
        <b-button
          class="addbtn"
          @click="
            ScheduleInterview.selectCand == true
              ? sendForApproval()
              : sendForOpshead()
          "
          >Send for Approval</b-button
        >
      </div>
    </b-modal>

    <!-- ******************************* total marksMODAL START************************************* -->

    <!-- ******************************* total mark MODAL END************************************* -->
    <!-- add mutiple candidate upload excel -->
    <!-- new designn  -->
    <b-modal
      id="excel-modal-center"
      centered
      hide-footer
      hide-header
      @show="removeExcelFromPopUp"
      @hidden="removeExcelFromPopUp"
      class="qb-add-ques-modal"
      no-stacking
      no-close-on-backdrop
    >
      <div>
        <div>
          <div
            @click="$bvModal.hide('excel-modal-center'), removeExcelModal()"
            class="xMarkCancel"
          >
            <img src="../../assets/xmark.svg" alt="" />
          </div>
          <div class="modalheading">Add Multiple Candidates</div>
          <hr />
          <b-form-file
            @input="handleClick"
            v-model="excelFile"
            ref="excel-upload-input"
            class="mb-2"
            placeholder="No File Chosen"
            accept=".xlsx, .xls"
          ></b-form-file>

          <div class="asterik mt-2" v-if="errorFile">
            Upload Failed!! Please upload supported format (.xls,.xlsx)
          </div>

          <div
            class="uploadfile-container p-2"
            v-if="excelFile && errorFile == false"
          >
            <div class="d-flex justify-content-between align-items-center mt-1">
              <div class="modalheading">{{ excelFile.name }}</div>

              <div>
                <img
                  src="../../assets/cross-round.svg"
                  alt=""
                  class="pointer"
                  @click="removeExcelFile()"
                />
              </div>
            </div>
            <div class="mt-3 relativeclass">
              <div class="fieldsetstyle modalheading">
                Select Sheet <span class="asterik">*</span>
              </div>
              <div
                class="
                  pointer
                  section-content
                  d-flex
                  justify-content-between
                  align-items-center
                "
                @click="showselecteddropdown = !showselecteddropdown"
              >
                <div class="sectionname">
                  <div>
                    <span
                      class="sbox-subtext cj-noofrecoption"
                      v-if="excelSheetNameShow.length != 0"
                    >
                      {{ excelSheetNameShow.length }} sheet(s) selected
                    </span>

                    <div v-else>Choose sheets</div>
                  </div>
                </div>

                <div class="pointer" v-if="showselecteddropdown">
                  <img src="../../assets/uparrow.svg" alt="" />
                </div>
                <div class="pointer" v-else>
                  <img src="../../assets/downarrow.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="dropdown-container" v-if="showselecteddropdown">
              <div class="relativeclass aoeinput">
                <div class="aoesearchicon-pos">
                  <img
                    src="../../assets/img/accesscontrol/inputsearch.svg"
                    alt=""
                  />
                </div>
                <b-form-input
                  class="input-field"
                  type="search"
                  placeholder="Search"
                  v-model="searchexcelsheets"
                >
                </b-form-input>

                <div class="height-dropdown-container pr-1 mt-2">
                  <b-form-group v-if="excelSheetNamesearch.length > 0">
                    <b-form-checkbox
                      class="secdropdowncolor p-2 pointer"
                      size="sm"
                      v-model="excelSheetNameShow"
                      v-for="option in excelSheetNamesearch"
                      :key="option"
                      :value="option"
                      @change="searchexcelsheets = ''"
                    >
                      {{ option }}
                    </b-form-checkbox>
                  </b-form-group>

                  <div
                    v-else
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      secdropdowncolor
                    "
                  >
                    No Matching results found for "{{ searchexcelsheets }}"
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 profile-details">
          <span class="asterik">*</span>
          <span
            >Click on download template button to fill out candidate details and
            upload the file</span
          >
        </div>

        <div class="mt-3 d-flex justify-content-between">
          <div>
            <b-button
              variant="outline"
              class="cursor-pointer p-2 ml-n2"
              @click="downloadMultipleTemplate"
            >
              <span
                ><img src="../../assets/img/downloadTemplate.svg" alt=""
              /></span>
              <span class="ml-2 downloadTmplateText">Download Template</span>
            </b-button>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div
              class="cancelbtntext pointer"
              @click="$bvModal.hide('excel-modal-center'), removeExcelFile()"
            >
              Cancel
            </div>
            <b-overlay :show="showExcelSpinner" rounded="sm" opacity="0.80">
              <b-button
                :disabled="uploadDisable"
                class="addbtn ml-3 pr-3 pl-3"
                @click="uploadExcel"
                >Upload</b-button
              >
            </b-overlay>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- add mutiple candidate upload excel  end-->

    <b-modal
      id="modal-multi-excel"
      size="xl"
      centered
      hide-footer
      hide-header
      class="p-0 jddetailsmodal"
      no-close-on-backdrop
    >
      <div
        class="
          page-heading
          d-flex
          justify-content-between
          align-items-center
          p-2
        "
      >
        <div class="jd-modal-heading">
          <span>List Of Candidates</span>
        </div>
      </div>
      <div
        class="xMarkCancel"
        @click="(donebtn = false), closeExcelModal(true)"
      >
        <img src="../../assets/cross-round.svg" alt="" />
      </div>

      <div class="tabbed">
        <b-tabs v-model="excelTabs">
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                <span>Passed</span>
                <div class="failed-count">{{ passedExcCandidates.length }}</div>
              </div>
            </template>
            <div>
              <div class="table-main" style="position: relative">
                <table
                  :aria-describedby="'Passed'"
                  class="
                    w-100
                    upload-candidate-table
                    jdtablecontent
                    upload-cand-modal
                  "
                >
                  <thead>
                    <tr>
                      <th style="width: 7%" class="text-center">Source</th>
                      <th style="width: 25%" class="text-center">
                        Candidate Name
                      </th>
                      <th style="width: 30%" class="text-center">Email ID</th>
                      <th style="width: 13%" class="text-center">Skills</th>
                      <th style="width: 5%"></th>
                      <th style="width: 20%" class="text-center">
                        Upload Resume
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(i, index) in passedExcCandidates" :key="index">
                      <td style="width: 7%" class="text-center">
                        <img
                          v-if="
                            i['Profile Source'] == 'other' ||
                            i['Profile Source'] == null
                          "
                          src="../../assets/img/talentpool/default.svg"
                          alt=""
                        />
                        <img
                          v-else-if="i['Profile Source'] == 'linkedin'"
                          src="../../assets/img/talentpool/linkdin.svg"
                          alt=""
                        />
                        <img
                          v-else-if="i['Profile Source'] == 'monster'"
                          src="../../assets/img/talentpool/monster.svg"
                          alt=""
                        />
                        <img
                          v-else-if="i['Profile Source'] == 'naukri'"
                          src="../../assets/img/talentpool/naukri.svg"
                          alt=""
                        />
                        <img
                          v-else-if="i['Profile Source'] == 'indeed'"
                          src="../../assets/img/talentpool/indeed.svg"
                          alt=""
                        />
                        <img
                          v-else-if="i['Profile Source'] == 'vendor'"
                          src="../../assets/img/talentpool/vendor.svg"
                          alt=""
                        />
                      </td>
                      <td style="width: 25%" class="text-center">
                        {{ i["Candidate Name"] }}
                      </td>
                      <td style="width: 30%" class="text-center mr-3">
                        {{ i.Email }}
                      </td>
                      <td style="width: 13%" class="text-center">
                        {{ i.Skill }}
                      </td>
                      <td style="width: 5%" class="text-center">
                        <div v-if="i.resume">
                          <img
                            src="../../assets/img/jddetails/resumeExists.svg"
                            alt=""
                            v-b-tooltip.hover.bottom="
                              'The candidate\'s resume is already uploaded.'
                            "
                          />
                        </div>
                      </td>
                      <td
                        class="
                          h-100
                          d-flex
                          justify-content-around
                          align-items-center
                        "
                      >
                        <template v-if="i.resumeName == null">
                          <b-overlay
                            :show="i.showUploadResume"
                            rounded="sm"
                            opacity="0.80"
                          >
                            <label class="custom-file-upload">
                              <input
                                type="file"
                                class="d-none"
                                accept=".pdf , .doc , .txt , .docx"
                                @input="uploadResume($event, index)"
                              />
                              <div class="d-flex align-items-center">
                                <img src="../../assets/uploadicon.svg" alt="" />
                                <span class="ml-1">Upload Resume</span>
                              </div>
                            </label>
                          </b-overlay>
                        </template>
                        <template v-else>
                          <b-overlay
                            :show="i.showUploadResume"
                            rounded="sm"
                            opacity="0.80"
                          >
                            <div
                              v-b-popover.hover.bottom="i.resumeName"
                              class="
                                custom-file-uploaded
                                d-flex
                                align-items-center
                                justify-content-between
                              "
                            >
                              <img
                                src="../../assets/img/jddetails/resumeuploaded.svg"
                                alt=""
                              />
                              <div class="resume-name">{{ i.resumeName }}</div>
                              <img
                                src="../../assets/img/jddetails/removeresume.svg"
                                alt=""
                                style="margin-top: 2px"
                                class="pointer"
                                @click="deleteResume(index)"
                              />
                            </div>
                          </b-overlay>
                        </template>
                        <img
                          @click="removeCandidate(index)"
                          class="pointer"
                          src="../../assets/img/jddetails/removecandidate.svg"
                          alt=""
                          v-b-tooltip.hover
                          title="Remove candidate"
                        />
                      </td>
                    </tr>
                    <tr
                      style="text-align: center"
                      v-if="passedExcCandidates.length === 0"
                    >
                      <td>No Records Found</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <b-button
                  class="addbtn done-btn"
                  @click="
                    donebtn ? '' : ((donebtn = true), closeExcelModal(true))
                  "
                  :disabled="resumeUploaded === 0"
                  >Done</b-button
                >
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="d-flex align-items-center justify-content-center">
                <span>Failed</span>
                <div class="failed-count">{{ failedExcCandidates.length }}</div>
              </div>
            </template>
            <div class="table-main">
              <table
                :aria-describedby="'Failed'"
                class="
                  w-100
                  upload-candidate-table
                  jdtablecontent
                  upload-cand-modal
                "
              >
                <thead>
                  <tr>
                    <th style="width: 7%" class="text-center">Source</th>
                    <th style="width: 30%" class="text-center">
                      Candidate Name
                    </th>
                    <th style="width: 30%" class="text-center">Email</th>
                    <th style="width: 13%" class="text-center">Skills</th>
                    <th style="width: 20%" class="text-center">Reason</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in failedExcCandidates" :key="index">
                    <td style="width: 7%" class="text-center">
                      <img
                        v-if="
                          i['Profile Source'] == 'other' ||
                          i['Profile Source'] == null
                        "
                        src="../../assets/img/talentpool/default.svg"
                        alt=""
                      />
                      <img
                        v-else-if="i['Profile Source'] == 'linkedin'"
                        src="../../assets/img/talentpool/linkdin.svg"
                        alt=""
                      />
                      <img
                        v-else-if="i['Profile Source'] == 'monster'"
                        src="../../assets/img/talentpool/monster.svg"
                        alt=""
                      />
                      <img
                        v-else-if="i['Profile Source'] == 'naukri'"
                        src="../../assets/img/talentpool/naukri.svg"
                        alt=""
                      />
                      <img
                        v-else-if="i['Profile Source'] == 'indeed'"
                        src="../../assets/img/talentpool/indeed.svg"
                        alt=""
                      />
                      <img
                        v-else-if="i['Profile Source'] == 'vendor'"
                        src="../../assets/img/talentpool/vendor.svg"
                        alt=""
                      />
                    </td>
                    <td style="width: 30%" class="text-center">
                      {{ i["Candidate Name"] }}
                    </td>
                    <td style="width: 30%" class="text-center">
                      {{ i.Email }}
                    </td>
                    <td style="width: 13%" class="text-center">
                      {{ i.Skill }}
                    </td>
                    <td style="width: 20%" class="text-center">
                      <img
                        src="../../assets/img/jddetails/failedupload.svg"
                        alt=""
                        :id="'failed' + i.Row"
                      />
                      <b-popover
                        :target="'failed' + i.Row"
                        triggers="hover"
                        placement="top"
                      >
                        <span>{{ i.Reason.join(",") }}</span>
                      </b-popover>
                    </td>
                  </tr>
                  <tr
                    style="text-align: center"
                    v-if="failedExcCandidates.length === 0"
                  >
                    <td>No Records Found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <b-modal
      id="resume-upload-confirm"
      size="md"
      centered
      hide-footer
      hide-header
      class="p-0"
      no-close-on-backdrop
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">Confirm</span>
      </div>
      <hr />
      <div
        class="xMarkCancel"
        @click="$bvModal.hide('resume-upload-confirm'), (donebtn = false)"
      >
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div class="final-select-modal-text-jd" v-if="donebtn == true">
        Please note for some candidates resume has not been uploaded,if you
        continue to end the process those candidates whose resume has not been
        uploaded from the list will not be added to this particular JD.
      </div>
      <div class="final-select-modal-text-jd" v-else>
        Please be aware that for certain candidates, resumes have already been
        uploaded. If you choose to close the modal, these candidates will not be
        added to the JD.
        <div>This action cannot be undone.</div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4">
        <b-overlay :show="showExcelSpinner" rounded="sm" opacity="0.80">
          <b-button
            class="addbtn"
            @click="showExcelSpinner ? '' : closeExcelModal(false)"
            >Confirm
          </b-button>
        </b-overlay>
        <div
          class="ml-3 cancelbtntext pointer"
          @click="$bvModal.hide('resume-upload-confirm'), (donebtn = false)"
        >
          Cancel
        </div>
      </div>
    </b-modal>
    <FolderModal
      :clearDetails="clearDetails"
      :showModal="showFolderModal"
      :selectedPanelProp="panelistsel"
      :userList="userList"
      @close-modal="showFolderModal = false"
      @myMethod="myMethod"
      @removepanel="removepanel"
      @clearObject="clearObject"
      ref="selectedpanel"
    ></FolderModal>
    <FinalOnHold :context="this" />
    />
    <CancelMeeting @cancel-meet="cancelMeet" />
    <FinalAction :context="this" />
    <History :context="this" />
    <ViewCandidate :context="this" @closeViewIcon="closeViewIcon" />
    <ScheduleModal :context="this" v-if="scheduleModal" />
    <FeedbackModal :context="this" />
    <ConfigureTestModal :context="this" />
    <ViewFeedback :context="this" />
    <RejectCandModal
      :activeCandidate="activeCandidate"
      :interviewProcess="interviewProcess"
      :configView="configView"
      :ScheduleInterview="ScheduleInterview"
      :userList="userList"
      :panelistSel="(val) => (panelistsel = val)"
      :configName="configName"
      :context="this"
      :rejectscheduleinterview="rejectscheduleinterview"
      :confirmmodal="confirmmodal"
      :rejectschedulemodal="rejectschedulemodal"
      :rejectsendassessment="rejectsendassessment"
      :externalPanFunc="(val) => (externalPan = val)"
      :changeModalScreen="
        (val1, val2, val3) => {
          if (val1 !== null) rejectschedulemodal = val1;
          if (val2 !== null) confirmmodal = val2;
          if (val3 !== null) rejectscheduleinterview = val3;
        }
      "
    />
    <NotInterested
      :notInterestedCandidate="notInterestedCandidate"
      :context="this"
    />

    <PhotosModal :context="this" />
    <AssesmentModal
      :configView="configView"
      :context="this"
      :configName="configName"
      :activeCandidate="activeCandidate"
      :selectedAssessment="selectedAssessment"
    />
    <ViewmarkModal :marksdetailsSuccess="marksdetailsSuccess" />
  </div>
</template>
<script>
const XLSX = require("xlsx");

import { mapGetters } from "vuex";
import { isExcel } from "../../utils/checkFiletype.js";
import jddetailsMixins from "../../views/kanban/jddetailsMixins.js";
import { downloadFeedback } from "../../utils/download.js";

import Spinner from "../../components/fixedcomponents/Spinner.vue";
import FolderModal from "../../components/teamsmodal/FolderModal.vue";
import FinalOnHold from "../../controllers/JD/modals/FinalOnHold.vue";
import CancelMeeting from "../../controllers/JD/modals/CancelMeeting.vue";
import FinalAction from "../../controllers/JD/modals/FinalAction.vue";
import History from "../../controllers/JD/modals/History.vue";
import ViewCandidate from "../../controllers/JD/modals/ViewCandidate.vue";
import ScheduleModal from "../../controllers/JD/modals/ScheduleModal.vue";
import FeedbackModal from "../../controllers/JD/modals/FeedbackModal.vue";
import ConfigureTestModal from "../../controllers/JD/modals/ConfigureTestModal.vue";
import ViewFeedback from "../../controllers/JD/modals/ViewFeedback.vue";
import RejectCandModal from "../../controllers/JD/modals/RejectCandModal.vue";
import ViewmarkModal from "../../controllers/JD/modals/ViewmarkModal.vue";
import NotInterested from "../../controllers/JD/modals/NotInterested.vue";
import PhotosModal from "../../components/Kanban/modal/PreviewImageModal.vue";
import AssesmentModal from "../../controllers/JD/modals/AssesmentModal.vue";
import { funnelChart } from "vue-d3-charts-hire3x";
import { NumbersOnly } from "../../controllers/Candidate/helpers";

import {
  addtojd,
  getScheduledInterview,
  getDraftJob,
  triggerAssessment,
  getCandidateRedis,
  downloadTemplate,
  uploadExcel,
  uploadExcResumeNew,
  funnelApi,
  allCandidatestoJD,
  uploadResumeExcel,
  addCandidateExcel,
  getVendorJdTalentPool,
} from "../../utils/apiFunctions.js";

export default {
  name: "JdDetails",
  mixins: [jddetailsMixins],
  components: {
    Spinner,
    FolderModal,
    FinalOnHold,
    CancelMeeting,
    FinalAction,
    History,
    ViewCandidate,
    ScheduleModal,
    FeedbackModal,
    ConfigureTestModal,
    ViewFeedback,
    RejectCandModal,
    NotInterested,
    PhotosModal,
    AssesmentModal,
    ViewmarkModal,
  },

  data() {
    return {
      scheduleModal: false,
      totalselectedCand: null,
      roomId: "",
      showViewmarkModal: false,
      donebtn: false,
      getCurrentDate: "",
      storeSourceof: "",
      storeAreaofexp: [],
      storeAssessmentStatus: "",
      storePopupSourceof: "",
      storePopupAreaofexp: [],
      addTPfiltercount: 0,
      tabFIndex: 0,
      addques1: false,
      addques2: false,
      globalWorks: false,

      openModal: false,
      rejectsendassessment: false,
      viewTaskHistory: 20,
      activeTab: "giveFeedback",
      panelistEmail: [],
      cancelModal: false,
      finalAction: false,
      totalPosition: 0,
      excelTabs: 0,
      totalCandidates: 0,
      totalSelected: 0,
      allCandTotal: 0,
      showExcelSpinner: false,
      searchQuery: "",
      uploadheight: "",
      uploadcandheight: "",
      panelistsel: {},
      filtercount: 0,
      timer: null,
      multiAssessSpinner: false,
      errorFile: false,
      searchexcelsheets: "",
      totalPage: null,
      userList: [],
      marksdetailsSuccess: {},
      marksdetails: {},
      candidateDetails: {
        evalDate: "",
        experience: "",
        modeOfInterview: "",
        name: "",
        panel: "",
      },
      clearAndCloseFdbk: false,
      applyflag: false,
      applyflagpopup: false,
      isAssessmentExist: false,
      goToPageMulti: "",
      modeOfInterview: "",
      tabIndex: 0,
      cancelCandidate: {},
      showFolderModal: false,
      clearDetails: false,
      externalPan: [],
      configTabIndex: 0,
      fileInputKey: 0,
      PopupTotal: null,
      total: 0,
      PopupCurrentPage: 1,
      candidatesUploading: [
        {
          resume: "",
        },
        {
          resume: "",
        },
        {
          resume: "",
        },
      ],
      currentPage: 1,
      totalques: 0,
      PopupTotalques: 0,
      PopupPagecount: 50,
      perPageCount: 50,
      PopupGoToPage: null,
      goToPage: null,
      excelFile: null,
      SheetName: "",
      jdsearchname: "",
      PopUptype: "1",
      niroundselected: "",
      searchPopUpCandidates: "",
      LoaderStatus: false,
      showselecteddropdown: false,
      notInterestedRemarks: "",
      teamsToken: "",
      activeCandidate: {},
      assessmentStatus: "",
      date: "",
      startTime: "",
      endTime: "",
      resumeFiles: "",
      image: "",
      candidateCapture: "",
      remarksForChanging: "",
      PopupNxtpg: "0",
      PopupPrevpg: "",
      configName: "",
      PopupPageStart: null,
      PopupPageEnd: null,
      PopupSourceof: "",
      PopupAreaofexp: [],
      PopupStatusValue: "createdAt",
      PopupSortByValue: false,
      meetingID: "",
      searchname: "",
      statusValue: "addedAt",
      sortByValue: false,
      nxtpg: "0",
      prevpg: "",
      pageStart: "",
      pageEnd: "",
      areaofexp: [],
      sourceof: "",
      tabLevel: "",
      searchSendCandidates: "",
      activeFolderPan: "",
      multiGoToPage: null,
      multiCurrentPage: 1,
      multiPerPageCount: 20,
      multiTotal: null,
      multiPageStart: null,
      multiPageEnd: null,
      panelDisable: true,
      isclick: false,
      PopupIsclickprev: false,
      screenshotname: "",
      isclickprev: false,
      dbfilterdrop: false,
      PopupDbfilterdrop: false,
      showfiltercard: false,
      PopupShowfiltercard: false,
      nischeddiv: false,
      niconfirmmodal: false,
      nischeduleinterview: false,
      showSpinner: false,
      scoreerror: false,
      allSelected: false,

      disableDropdown: false,
      disableText: true,
      PopupIsclick: false,
      assessdrop: false,
      sendallmulti: false,
      assessmentScheduleType: "false",
      addCandidateToggle: false,
      filter: false,
      filledfdbckform: {},
      notInterestedCandidate: {},
      selectedAssessment: {},
      selectTestToShare: {},
      feedbackform: {},
      finalSelectedCandidate: {},
      interviewProcess: {
        process: [],
      },
      individualMark: {},
      excelSheetName: [],
      excelSheetNameShow: [],
      multisendcandidates: [],
      sendmultiselected: [],
      passedExcCandidates: [],
      failedExcCandidates: [],
      resumeUploaded: 0,
      testConfigData: {
        config: {
          texteditablename: false,
          testOrg: "",
          testDesc: "",
          testInst: "",
          dispRealdt: false,
          dispDuration: false,
          dispCount: false,
          allowCandidateRemarks: false,
          autoCorrection: true,
          quesPerScreen: "10",
          sectionnum: "The No. of sections(Non-Editable)",
          shuffle: false,
          sortoptions_selected: "",
          dispReqStatus: true,
          displayReqFirst: false,
          dispMarks: false,
          test: "public",
          allowAgent: false,
          allowImageAndIdCapture: false,
          allowExtension: false,
          includeTimer: false,
          negativeAutoCorrect: false,
          negativeMarkValue: null,
          timer: null,
          timebnsel: "",
          openTestdt: null,
          closeTestdt: null,
          testDuration: 30,
          includeTimeNotifics: false,
          autoSave: false,
          enableCamera: false,
          navLock: false,
          includeEndTest: false,
          instantemail: false,
          imageCapture: 0,
          screenCapture: 0,
          topic: "",
          options: [
            {
              item: true,
              name: "Yes",
            },
            {
              item: false,
              name: "No",
            },
          ],

          monitoringType: false,
          dosAndDonts: [
            {
              value: "",
            },
          ],
        },
      },
      ScheduleInterview: {
        date: "",
        startTime: "",
        endTime: "",
        meetingLink: "",
        storeLink: "",
        storeVcclLink: "",
        storeNoneLink: "",

        meetingSummary: "",
        externalPanelist: [],
        candidate: {},
        requiredPanel: null,
        jobID: "",
        customerID: "",
        teams: true,
        panelist: {},
        roundlevel: "",
        schedulename: "",
        toolTipTitle: "Copy",
        errorpanel: false,
        scheduleButton: "",
        teamsStatus: null,
        panelistStatus: null,
        withTeams: false,
        withVccl: false,
        selectedOption: "Microsoft Teams",
        recruiterRemarks: "",
        meetingID: "",
        roomId: "",
        selectCand: false,
        vcclResponse: {},

        showError: false,
      },
      imageError: false,
      requiredPanel: null,
      errorpanel: false,
      teamsStatus: null,
      panelistStatus: null,
      rejectschedulemodal: false,
      confirmmodal: false,
      rejectscheduleinterview: false,
      feedback: {
        interviewID: "",
        name: "",
        panelName: "",
        experience: "",
        modeOfInterview: "",
        evalDate: "",
        recommendation: "",
        candidateImage: "",
        processedBy: "",
        feedbackForm: "",
        recruiterRemarks: "",
        sendOpshead: false,
        externalPanelist: [],
      },
      selectedCandidate: {
        assessmentResponse: {
          data: {
            status: null,
          },
        },
      },

      jdSelectCand: [],
      candidateTalentPool: [],
      feedbackHistory: [],
      saveAllCandidate: [],
      panellistSelected: [],
      PopupSource_options: [
        {
          value: null,
          text: "Source",
          notEnabled: true,
        },
        {
          value: "naukri",
          text: "Naukri",
        },
        {
          value: "monster",
          text: "Monster",
        },
        {
          value: "indeed",
          text: "Indeed",
        },
        {
          value: "linkedin",
          text: "Linkedin",
        },
        {
          value: "vendor",
          text: "Vendor",
        },
        {
          value: "others",
          text: "Others",
        },
      ],
      assessmentStatus_options: [
        {
          value: null,
          text: "Assessment",
          notEnabled: true,
        },
        {
          value: "Yet to Start",
          text: "Yet to Start",
        },
        {
          value: "On Going",
          text: "On Going",
        },
        {
          value: "Completed",
          text: "Completed",
        },
      ],
      source_options: [
        {
          value: null,
          text: "Source",
          notEnabled: true,
        },
        {
          value: "Naukri",
          text: "Naukri",
        },
        {
          value: "Monster",
          text: "Monster",
        },
        {
          value: "Indeed",
          text: "Indeed",
        },
        {
          value: "Linkedin",
          text: "Linkedin",
        },
        {
          value: "vendor",
          text: "Vendor",
        },

        {
          value: "Others",
          text: "Others",
        },
      ],

      down: false,
      opsHeadList: [],
      opsHeadName: [],
      select_opsHeadName: "",
      opsHeadRemarks: "",
      approverUserID: "",
    };
  },
  watch: {
    searchSendCandidates() {
      if (this.searchSendCandidates === "") {
        this.handleKeyPress();
        let current = this.multiCurrentPage;
        this.multiCurrentPage = 1;
        if (current === this.multiCurrentPage) {
          this.getSendMultipleJob();
        }
      }
    },
    searchname() {
      if (this.searchname === "") {
        this.getJobDetails();
      }
    },
    externalPan() {
      if (this.externalPan.length > 0) {
        this.ScheduleInterview.errorpanel = false;
      }
    },
    jdSelectCand() {
      // Handle changes in individual flavour checkboxes
      if (this.jdSelectCand.length == this.candidateTalentPool.length) {
        this.allSelected = true;
      }
    },
    // searchPopUpCandidates() {
    //   if (this.searchPopUpCandidates === "") {
    //     this.searchTalentPool();
    //   }
    // },
    tabIndex(newValue) {
      let status;
      // Map the tabIndex value to the corresponding status
      switch (newValue) {
        case 0:
          status = "show";
          break;
        case 1:
          status = "hired";
          break;
        case 2:
          status = "notintrested";
          break;
        case 3:
          status = "onhold";
          break;
        case 4:
          status = "rejected";
          break;
        default:
          status = "show";
          break;
      }
      // Update the route with the new status query parameter
      this.$router.push({
        path: "/jobs/jddetails",
        query: {
          jobID: this.$route.query.jobID,
          jobTitle: this.$route.query.jobTitle,
          customerID: this.$route.query.customerID,
          cardName: this.$route.query.cardName,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: status,
        },
      });
    },
  },
  filters: {
    fnName: function (value) {
      if (value.length <= 3) {
        return value.slice(0, 3) + " ";
      } else {
        return value.slice(0, 3) + "...";
      }
    },

    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },
  computed: {
    isConfigExpiredForAll() {
      return this.multisendcandidates.every(
        (candidate) => candidate.isConfigExpired
      );
    },

    noCandWithDocs() {
      for (let candidate of this.multisendcandidates) {
        if (
          candidate.documentStatus === 1 ||
          candidate.documentStatus === null
        ) {
          return false;
        }
      }
      return true;
    },
    // it is used to search the data when the sheets dropdown is true
    excelSheetNamesearch() {
      return this.excelSheetName.filter((data) => {
        return (
          !this.searchexcelsheets ||
          data.toLowerCase().includes(this.searchexcelsheets.toLowerCase())
        );
      });
    },
    // the upload button must be disabled if the below mentioned properties are true
    uploadDisable() {
      return this.excelFile === null || this.excelSheetNameShow.length === 0;
    },

    iscontainsNumber() {
      return !/^\d+$/.test(this.goToPage);
    },
    iscontainsNumberPopup() {
      return !/^\d+$/.test(this.PopupGoToPage);
    },
    ...mapGetters("userVUEX", {
      menuStatus: "getMenuStatus",
      licenseKey: "getlicenseKey",
    }),
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
    ...mapGetters(["roles"]),
    PopupTotalPages() {
      return Math.ceil(this.PopupTotal / this.PopupPagecount);
    },
    multiTotalPages() {
      return Math.ceil(this.multiTotal / this.multiPerPageCount);
    },

    tryAgain() {
      let game = [];
      for (let i in this.selectedCandidate.skills) {
        game.push(this.selectedCandidate.skills[i]);
      }
      let commasep = game.join(",");
      return commasep;
    },
    isEmpty: ({ jdSelectCand }) => jdSelectCand.length === 0,
  },
  created() {
    this.LoaderStatus = true;
    this.getPerticularJobDescription();
    this.allCandidatestoJD();
    this.setTabIndex();
  },

  methods: {
    downloadResume(url) {
      downloadFeedback(url);
    },
    closeViewIcon() {
      this.selectedCandidate = {};
    },
    applyJDFilterTest() {
      this.filtercount = 0;
      this.statusValue = "addedAt";
      this.getJobDetails();
      this.storeSourceof = this.sourceof; // Revert to the stored PopupSourceof value
      this.storeAreaofexp = this.areaofexp;
      this.storeAssessmentStatus = this.assessmentStatus;
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    closeAddCand() {
      this.addCandidateToggle = false;
    },
    closejDdetailsFilter() {
      this.showfiltercard = false; // Hide the filter card
      this.dbfilterdrop = false; // Hide the source card
      this.sourceof = this.storeSourceof; // Revert to the stored PopupSourceof value
      this.areaofexp = this.storeAreaofexp;
      this.assessmentStatus = this.storeAssessmentStatus;
    },
    // v-closable for source in talent pool filter
    filtercloseSource() {
      this.PopupDbfilterdrop = false;
    },
    // This method is called when the user closes the filter card.
    closeTalentPoolFilter() {
      this.PopupShowfiltercard = false; // Hide the filter card
      this.PopupDbfilterdrop = false; // Hide the source card
      this.PopupSourceof = this.storePopupSourceof; // Revert to the stored PopupSourceof value
      this.PopupAreaofexp = this.storePopupAreaofexp; // Revert to the stored PopupAreaofexp value
    },
    // This method is called when the user clicks the "Apply" button in the filter card.
    applyFilterTest() {
      this.PopupShowfiltercard = false; // Hide the filter card
      this.addTPfiltercount = 0; // Reset the filter count
      if (this.PopupSourceof != "") {
        this.addTPfiltercount++; // Increment the filter count if PopupSourceof is not empty
      }
      if (this.PopupAreaofexp.length != 0) {
        this.addTPfiltercount++;
      }
      // Update the stored values with the current filter values
      this.storePopupSourceof = this.PopupSourceof;
      this.storePopupAreaofexp = this.PopupAreaofexp;
      this.showAllCandidates(); // Retrieve the filtered candidates
    },
    // This method is called when the user clicks the "Clear Filter
    PopupClearfilter() {
      this.storePopupSourceof = "";
      this.storePopupAreaofexp = [];
      this.PopupSourceof = "";
      this.PopupAreaofexp = [];

      // If filters were previously applied, retrieve all candidates to show unfiltered list
      if (this.applyflagpopup) {
        this.PopupStatusValue = "";

        this.showAllCandidates();
      }
      this.applyflagpopup = false;
      this.addTPfiltercount = 0;
    },
    validateText(val) {
      this.dirtyCheckDescQuestion = val;
    },
    updateQuestionContent(newContent) {
      this.testConfigData.config.testDesc = newContent;
    },
    changedaddQues(newval) {
      this.addques1 = newval;
    },

    validateText2(val) {
      this.dirtyCheckQuestion = val;
    },
    updateQuestionContent2(newContent) {
      this.testConfigData.config.testInst = newContent;
    },
    changedaddQues2(newval) {
      this.addques2 = newval;
    },
    closeSource() {
      this.dbfilterdrop = false;
    },
    closeAssessment() {
      this.assessdrop = false;
    },
    roundClass(round) {
      return {
        "jd-firstround": round === "0",
        "jd-secondround": round === "1",
        "jd-thirdround": round === "2",
        "jd-fourthround": round === "3",
        "jd-fifthround": round === "4",
        "jd-sixthround": round === "5",
        "jd-seventhround": round === "6",
        "jd-eighthround": round === "7",
        "jd-ninthround": round === "8",
        "jd-tenthround": round === "9",
        "jd-lastround": round === "10",
      };
    },
    getRoundName(level) {
      if (level === "F") {
        return "Selected";
      } else if (level === "NI") {
        return "Not Interested";
      } else if (level === "R") {
        return "Rejected";
      }
      return "On-Hold";
    },
    checkValidRound(level) {
      return level !== "F" && level !== "R" && level !== "NI" && level !== "H";
    },
    filterTalentPool(...flag) {
      this.PopupStatusValue = flag[0];
      this.PopupSortByValue = flag[1];
      this.filter = true;
      this.showAllCandidates();
    },
    searchTalentPool() {
      this.PopupStatusValue = "";
      this.PopupCurrentPage = 1;
      this.showAllCandidates();
    },
    switchPopUpTabs(flag) {
      this.PopUptype = flag;
      this.PopupGoToPage = null;
      this.PopupCurrentPage = 1;
      this.allSelected = false;
      this.jdSelectCand = [];
      this.PopupStatusValue = "";
      this.filter = false;
      this.showAllCandidates();
    },
    filterCandidates(...flag) {
      if (this.saveAllCandidate.length > 0) {
        this.statusValue = flag[0];
        this.sortByValue = flag[1];
        this.filter = true;
        this.getJobDetails();
      }
    },
    switchTabs(flag) {
      this.tabLevel = flag;
      this.goToPage = null;
      this.currentPage = 1;
      this.jdSelectCand = [];
      this.allSelected = false;
      this.saveAllCandidate = [];
      this.statusValue = "";
      this.getJobDetails();
    },
    handleKeyPress() {
      window.clearTimeout(this.timer);
    },

    clearMultiAssessFields(flag) {
      this.sendallmulti = false;
      this.searchSendCandidates = "";
      this.assessmentScheduleType = flag;
      this.multisendcandidates = [];
      this.sendmultiselected = [];

      this.getSendMultipleJob();
    },
    async openMultiAssessModal() {
      this.multiCurrentPage = 1;
      this.sendmultiselected = [];
      this.assessmentScheduleType = "false";
      this.LoaderStatus = true;
      await this.getSendMultipleJob();
      this.LoaderStatus = false;
      this.$bvModal.show("sendmultiasessmodal");
    },
    setTabIndex() {
      switch (this.$route.query.status) {
        case "show":
          this.tabIndex = 0;
          this.tabLevel = "SH";
          break;
        case "hired":
          this.tabIndex = 1;
          this.tabLevel = "F";
          break;
        case "notintrested":
          this.tabIndex = 2;
          this.tabLevel = "NI";
          break;
        case "onhold":
          this.tabIndex = 3;
          this.tabLevel = "H";
          break;
        case "rejected":
          this.tabIndex = 4;
          this.tabLevel = "R";
          break;
        default:
          this.tabIndex = 0;
          break;
      }
      this.goToPage = null;
      this.currentPage = 1;
      this.getJobDetails("tab");
    },
    removepanel() {
      this.ScheduleInterview.panelist = {};
    },

    async makeFunnelGraph() {
      if (document.getElementById("funnel").innerHTML != "") {
        document.getElementById("funnel").innerHTML = "";
      }
      const payload = {
        jobID: this.$route.query.jobID,
      };
      const response = await funnelApi(payload);
      if (response.status == 200) {
        let originalData = response.data.data.data;
        let e = new funnelChart();
        e.createFunnel(originalData);
        this.totalselectedCand = response.data.data.details.selected;
      }
    },

    async closeExcelModal(flag) {
      if (flag) {
        if (this.resumeUploaded < this.passedExcCandidates.length) {
          this.$bvModal.show("resume-upload-confirm");
          return;
        }
      }
      if (
        this.resumeUploaded > 0 &&
        this.passedExcCandidates.length > 0 &&
        this.donebtn
      ) {
        try {
          this.showExcelSpinner = true;
          let payload = {
            emailIDs: [],
            customerID: this.$route.query.customerID,
            jobID: this.$route.query.jobID,
          };
          for (let candidate of this.passedExcCandidates) {
            if (candidate.resumeName !== null) {
              payload.emailIDs.push(candidate.Email);
            }
          }
          const response = await addCandidateExcel(payload);
          if (response.status == 200) {
            this.donebtn = false;
            this.successModal("Candidates added successfully");
            this.getJobDetails();
          }
        } catch (error) {
          this.showExcelSpinner = false;
          this.donebtn = false;
          console.error(error);
        }
      }
      this.showExcelSpinner = false;
      this.resumeUploaded = 0;
      this.excelTabs = 0;
      this.$bvModal.hide("resume-upload-confirm");
      this.$bvModal.hide("modal-multi-excel");
    },
    // NAVIGATE TO VIEW REQUIRED DOCUMENTS

    //router go back
    gobackpointer() {
      this.$router.push({
        name: `InternalHiringDashboard`,
        params: {
          cardName: this.$route.query.cardName,
          customerID: this.$route.query.customerID,
        },
      });
    },
    // CHECK MAIL OF PARTICULAR DOMAIN
    // IN FUTURE IF MORE HARDCODED DOMAINS ARE NEEDED,THEN ADD IT AT THE END OF RETURN STATEMENT
    companyMail(mail) {
      return (
        mail === "elevancehealth.com" ||
        mail === "legato.com" ||
        mail === "anthem.com" ||
        mail === "carelon.com"
      );
    },

    // EXCEL FILE UPLOAD
    handleClick: function (event) {
      this.excelSheetNameShow = [];
      this.errorFile = false;
      const parts = event.name.split(".");
      const ext = parts[parts.length - 1];
      if (isExcel(ext)) {
        if (this.excelFile) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            this.excelSheetName = wb.SheetNames;
            if (this.excelSheetName.length == 1) {
              this.excelSheetNameShow.push(this.excelSheetName[0]);
            }
          };
          reader.readAsBinaryString(this.excelFile);
        }
      } else {
        this.errorFile = true;
      }
    },

    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },

    removeExcelFromPopUp() {
      this.excelFile = null;
      this.excelSheetNameShow = [];
    },
    removeExcelFile() {
      this.$bvModal.hide("modal-multi-excel");
      this.excelFile = null;
      this.excelSheetNameShow = [];
      this.excelSheetName = [];
      this.searchexcelsheets = "";
      this.showselecteddropdown = false;
      this.$forceUpdate();
    },
    removeExcelModal() {
      this.excelFile = null;
      this.excelSheetNameShow = [];
      this.excelSheetName = [];
      this.searchexcelsheets = "";
      this.showselecteddropdown = false;
      this.$forceUpdate();
    },

    //DELETE A RESUME AFTER UPLOADING FOR EXCEL CANDIDATES
    async deleteResume(index) {
      this.passedExcCandidates[index].showUploadResume = true;
      this.$forceUpdate();
      let form = new FormData();
      form.append("email", this.passedExcCandidates[index].Email);
      form.append("deleteResume", "");
      const response = await uploadExcResumeNew(form);
      if (response.status == 200) {
        this.passedExcCandidates[index].resumeName = null;
        this.passedExcCandidates[index].resume = false;
        this.resumeUploaded--;
        this.$forceUpdate();
      }
      this.passedExcCandidates[index].showUploadResume = false;
    },

    removeCandidate(index) {
      if (
        this.passedExcCandidates[index].resume ||
        this.passedExcCandidates[index].resumeName !== null
      ) {
        this.resumeUploaded--;
      }
      this.passedExcCandidates.splice(index, 1);
    },

    //UPLOAD RESUME FOR EXCEL CANDIDATES
    async uploadResume(event, index) {
      const input = event.target;
      if (input?.files?.[0]) {
        this.passedExcCandidates[index].showUploadResume = true;
        this.$forceUpdate();
        let resumeName = input.files[0].name;
        let reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        let filess = input.files[0];
        let form = new FormData();
        form.append("email", this.passedExcCandidates[index].Email);
        form.append("resume", filess);
        const response = await uploadResumeExcel(form);
        if (response.status == 200) {
          this.passedExcCandidates[index].resumeName = resumeName;
          this.resumeUploaded++;
          this.$forceUpdate();
        }
        this.passedExcCandidates[index].showUploadResume = false;
      }
    },

    // OPEN MODEL FOR DISPLAYING PASSED AND FAILED CANDIDATES
    async openCenterModal() {
      this.PopUptype = "1";
      this.PopupStatusValue = "createdAt";
      this.PopupSortByValue = false;
      await this.showAllCandidates();
      this.addCandidateToggle = false;
      this.$bvModal.show("modal-center");
    },

    //OPEN MODAL FOR UPLOADING EXCEL
    openExcelModal() {
      this.addCandidateToggle = false;
      this.$bvModal.show("excel-modal-center");
    },

    // ADD SELECTED PANELIST DATA INTO THE ACTUAL OBJECT AND CHECK TEAMS STATUS

    async allCandidatestoJD() {
      try {
        const payload = {
          jobID: this.$route.query.jobID,
          sortBy: {
            column: "",
            order: "",
          },
          searchQueries: "",
          count: 1,
          page: 0,
          filters: {
            status: "0",
          },
        };
        const res = await allCandidatestoJD(payload);
        if (res.status == 200) {
          this.allCandTotal = res.data.data.total;
        }
      } catch (error) {
        return error;
      }
    },
    async getPerticularJobDescription() {
      try {
        let payload = {
          type: 1,
          jobID: this.$route.query.jobID,
        };
        const res = await getDraftJob(payload);
        if (res.status == 200) {
          this.totalPosition = res.data.data.details.position;
          this.totalCandidates = res.data.data.details.candidates;
          this.totalSelected = res.data.data.details.selected;

          this.isAssessmentExist = res.data.data.isAssessmentExist;
          const temp = res.data.data.interviewProcess.process;
          this.interviewProcess.process = [];
          for (let i in temp) {
            this.interviewProcess.process.push(temp[i]);
          }
          const panelists = res.data.data.assignedPanelist;
          panelists.forEach((panel) =>
            this.userList.push({
              userID: panel.userID,
              folderID: panel.folderID,
            })
          );
          this.requiredPanel = res.data.data.showAllPanelist;
          this.makeFunnelGraph();
          this.getJobDetails();
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // GO TO SPECIFIC PAGE IN MULTIPLE ASSESSMENT MODEL
    jumpToPage(index) {
      if (index > 0) {
        this.multiCurrentPage = Math.min(
          Math.max(1, index),
          this.multiTotalPages
        );
        this.getSendMultipleJob();
        this.PopupGoToPage = null;
      }
    },

    async getSendMultipleJob() {
      this.multiAssessSpinner = true;
      try {
        let payload = {
          type: "1",
          page: this.multiCurrentPage - 1,
          count: this.multiPerPageCount,
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          sortBy: {
            column: "addedAt",
            order: true,
          },
          filters: { assessmentScheduled: this.assessmentScheduleType },
          searchQuery: this.searchSendCandidates,
        };
        const res = await getCandidateRedis(payload);
        if (res.status == 200) {
          this.multisendcandidates = res.data.data.data;
          this.multiPageStart = res.data.data.pageStart;
          this.multiPageEnd = res.data.data.pageEnd;
          this.multiTotal = res.data.data.total;
          this.checkSelectAllMulti();
          this.goToPageMulti = "";
        }
        this.multiAssessSpinner = false;
      } catch (error) {
        this.multiAssessSpinner = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    textSearch() {
      this.statusValue = "addedAt";
      this.sortByValue = true;
      this.currentPage = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.LoaderStatus = true;
        this.getJobDetails();
      }, 400);
    },
    // Get Candidate Pagination APi
    getsaveAllCandidate() {
      for (let i in this.saveAllCandidate) {
        for (let j in this.interviewProcess.process) {
          if (
            this.saveAllCandidate[i].kanbanLevel == 0 ||
            this.saveAllCandidate[i].kanbanLevel == "NI"
          ) {
            if (this.interviewProcess.process[1].type == "assesment") {
              this.saveAllCandidate[i].type = "assesment";
              this.saveAllCandidate[i].sentAutomatically =
                this.interviewProcess.process[1].sentAutomatically;
              this.saveAllCandidate[i].selectedtests =
                this.interviewProcess.process[1].selectedtests;
              this.saveAllCandidate[i].configID =
                this.interviewProcess.process[1].configID;
            } else if (
              this.interviewProcess.process[1].type == "f2f" ||
              this.saveAllCandidate[i].kanbanLevel == "R"
            ) {
              this.saveAllCandidate[i].type = "f2f";
            }
          } else if (
            this.saveAllCandidate[i].kanbanLevel ==
            parseInt(this.interviewProcess.process[j].id)
          ) {
            this.getSelectedTests(i, j);
          }
        }
      }
    },
    getSelectedTests(i, j) {
      if (this.interviewProcess.process[j].type == "assesment") {
        this.saveAllCandidate[i].type = "assesment";
        this.saveAllCandidate[i].sentAutomatically =
          this.interviewProcess.process[j].sentAutomatically;
        this.saveAllCandidate[i].selectedtests =
          this.interviewProcess.process[j].selectedtests;
        this.saveAllCandidate[i].configID =
          this.interviewProcess.process[j].configID;
      } else if (this.interviewProcess.process[j].type == "f2f") {
        this.saveAllCandidate[i].type = "f2f";
      }
    },
    // Get Candidate Pagination APi
    async getJobDetails() {
      this.LoaderStatus = true;
      this.applyflag = true;
      let assessmentStatus = "";
      if (this.assessmentStatus == "Yet to Start") {
        assessmentStatus = "0";
      } else if (this.assessmentStatus == "On Going") {
        assessmentStatus = "1";
      } else if (this.assessmentStatus == "Completed") {
        assessmentStatus = "2";
      }
      if (this.areaofexp.length !== 0 && this.tabLevel == "") {
        this.filtercount++;
      }
      if (this.sourceof !== "" && this.tabLevel == "") {
        this.filtercount++;
      }
      if (assessmentStatus !== "" && this.tabLevel == "") {
        this.filtercount++;
      }
      if (this.tabLevel == "SH") {
        this.tabLevel = "";
      }
      let payload = {
        type: "2",
        page: this.currentPage - 1,
        count: this.perPageCount,
        jobID: this.$route.query.jobID,
        customerID: this.$route.query.customerID,
        sortBy: { column: this.statusValue, order: this.sortByValue },
        level: this.tabLevel,
        filters: { skillSets: this.areaofexp, source: this.sourceof },
        assessmentStatus: assessmentStatus,
        searchQuery: this.searchname,
      };

      if (this.filtercount > 0) {
        this.LoaderStatus = true;
        this.showfiltercard = false;
      }
      const data = await getCandidateRedis(payload);
      if (data.status == 200) {
        this.makeFunnelGraph();
        this.LoaderStatus = false;
        this.saveAllCandidate = data.data.data.data;
        this.nxtpg = data.data.data.nextPage;
        this.prevpg = data.data.data.prevPage;
        this.pageStart = data.data.data.pageStart;
        this.pageEnd = data.data.data.pageEnd;
        this.total = data.data.data.total;
        if (this.currentPage == 0) {
          this.totalques = this.saveAllCandidate.length;
        }
        this.getsaveAllCandidate();

        this.LoaderStatus = false;
      }
    },
    gotopgnum() {
      if (this.goToPage >= 1) {
        this.currentPage = this.goToPage;
        this.goToPage = "";
      }
    },
    prevpage() {
      this.isclick = false;
      this.isclickprev = true;
      if (this.currentPage > 0) {
        this.currentPage = this.currentPage - 1;
        this.totalques -= this.saveAllCandidate.length;
      }
      this.getJobDetails();
    },
    nextpage() {
      this.isclickprev = false;
      this.isclick = true;
      if (this.nxtpg != null) {
        this.currentPage = this.currentPage + 1;
        this.totalques += this.saveAllCandidate.length;
      }
      this.getJobDetails();
    },
    clearfilter(flag) {
      this.applyflag = flag;
      this.filtercount = 0;
      this.storeSourceof = "";
      this.storeAreaofexp = [];
      this.storeAssessmentStatus = "";
      this.sourceof = "";
      this.areaofexp = [];
      this.assessmentStatus = "";
      if (this.applyflag) {
        this.statusValue = "addedAt";
        this.getJobDetails();
      }
      this.applyflag = false;
    },
    editjdcandidate(candidate) {
      this.$router.push({
        path: `/addcandidate/editcandidate/${candidate.candidateID}`,
        query: {
          active: candidate.active,
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          jobTitle: this.$route.query.jobTitle,
          cardName: this.$route.query.cardName,
          status: this.$route.query.status,
        },
      });
    },
    viewCandidate(Details) {
      this.selectedCandidate = Details;
      this.$bvModal.show("view-modal");
    },
    selectAll() {
      if (this.allSelected) {
        for (let i in this.candidateTalentPool)
          if (
            this.jdSelectCand.filter(
              (value) => value == this.candidateTalentPool[i].candidateID
            ).length === 0 &&
            this.candidateTalentPool[i].resume != null
          ) {
            this.jdSelectCand.push(this.candidateTalentPool[i].candidateID);
          }
      } else {
        for (let j in this.candidateTalentPool) {
          if (
            this.jdSelectCand.filter(
              (value) => value == this.candidateTalentPool[j].candidateID
            ).length > 0
          ) {
            this.jdSelectCand.splice(
              this.jdSelectCand.indexOf(
                this.candidateTalentPool[j].candidateID
              ),
              1
            );
          }
        }
      }
    },
    deselect() {
      this.allSelected = false;
      const containsAll = this.candidateTalentPool.every((element) => {
        return (
          this.jdSelectCand.includes(element.candidateID) ||
          !element.resume ||
          element.resume == null
        );
      });

      if (containsAll) {
        this.allSelected = true;
      }
    },

    checkSelectAll() {
      let isSelectedAll = true;
      if (this.candidateTalentPool.length !== 0) {
        for (let i of this.candidateTalentPool) {
          let record = this.candidateTalentPool[i];
          if (
            this.jdSelectCand.filter((value) => value == record.candidateID)
              .length === 0
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }
      this.allSelected = isSelectedAll;
    },
    async sendToMutliple() {
      this.showSpinner = true;
      try {
        const payload = {
          panelList: [],
          candidateID: [],
          jobID: "",
          customerID: "",
          level: {},
        };
        payload.customerID = this.$route.query.customerID;
        payload.jobID = this.$route.query.jobID;
        for (let i in this.sendmultiselected) {
          payload.candidateID.push(this.sendmultiselected[i].candidateID);
          if (this.sendmultiselected[i].kanbanLevel == 0) {
            payload.level[this.sendmultiselected[i].candidateID] =
              parseInt(this.sendmultiselected[i].kanbanLevel) + 1;
          } else {
            payload.level[this.sendmultiselected[i].candidateID] = parseInt(
              this.sendmultiselected[i].kanbanLevel
            );
          }
        }

        const panel = "cvinfra@simplify3x.com";
        payload.panelList.push(panel);
        const res = await triggerAssessment(payload);
        if (res.status == 200) {
          this.sendmultiselected = [];
          this.successModal(
            "Assessment Shared to all Selected Candidates Successfully"
          );
          this.showSpinner = false;
          this.$bvModal.hide("confirmmultiplesend");
          this.$bvModal.hide("sendmultiasessmodal");
          this.getJobDetails();
        }
      } catch (error) {
        this.showSpinner = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    selectAllMulti() {
      if (this.sendallmulti) {
        for (let i in this.multisendcandidates) {
          if (
            this.multisendcandidates[i].documentStatus !== 1 &&
            this.multisendcandidates[i].documentStatus !== null
          ) {
            continue;
          }
          if (
            this.sendmultiselected.filter(
              (value) =>
                value.candidateID == this.multisendcandidates[i].candidateID
            ).length === 0
          ) {
            let data = {
              candidateID: this.multisendcandidates[i].candidateID,
              kanbanLevel: this.multisendcandidates[i].kanbanLevel,
            };
            this.sendmultiselected.push(data);
          }
        }
      } else {
        this.selectMultipleAssesment();
      }
    },
    selectMultipleAssesment() {
      for (let j in this.multisendcandidates) {
        if (
          this.sendmultiselected.filter(
            (value) =>
              value.candidateID == this.multisendcandidates[j].candidateID
          ).length > 0
        ) {
          this.sendmultiselected.splice(
            this.sendmultiselected.findIndex(
              (value) =>
                value.candidateID === this.multisendcandidates[j].candidateID
            ),
            1
          );
        }
      }
    },
    deselectmulti() {
      this.sendallmulti = false;

      const activeCandidates = this.multisendcandidates.filter(
        (element) => element.isConfigExpired !== true
      );

      const containsAllActive = activeCandidates.every((element) => {
        if (element.documentStatus !== null && element.documentStatus !== 1) {
          return true;
        }
        return this.sendmultiselected.some(
          (value) => value.candidateID === element.candidateID
        );
      });

      if (containsAllActive) {
        this.sendallmulti = true;
      }
    },
    checkSelectAllMulti() {
      let isSelectedAll = true;
      if (this.multisendcandidates.length !== 0) {
        for (const i of this.multisendcandidates) {
          let record = i.candidateID;
          if (
            this.sendmultiselected.filter(
              (value) => value.candidateID == record
            ).length === 0
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }
      this.sendallmulti = isSelectedAll;
    },
    // Pagination Api for Add Candidate PopUp
    async showAllCandidates() {
      this.showSpinner = true;
      try {
        this.applyflagpopup = true;

        let payload = {
          type: this.PopUptype,
          page: this.PopupCurrentPage - 1,
          count: this.PopupPagecount,
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          sortBy: {
            column: this.PopupStatusValue,
            order: this.PopupSortByValue,
          },
          source: this.PopupSourceof,
          skills: this.PopupAreaofexp,
          searchQuery: this.searchPopUpCandidates,
          popup: true,
        };

        const response = await getVendorJdTalentPool(payload);
        if (response.status == 200) {
          this.allSelected = false;
          this.candidateTalentPool = response.data.data.data;
          this.PopupPageStart = response.data.data.pageStart;
          this.PopupPageEnd = response.data.data.pageEnd;
          this.PopupTotal = response.data.data.total;
          this.checkSelectAll();
          this.totalPage = Math.ceil(
            parseInt(this.PopupTotal) / parseInt(this.PopupPagecount)
          );
          this.showSpinner = false;
        }
      } catch (error) {
        this.showSpinner = false;
        throw new Error(`Failed! Getting Talent Candidates:${error.status}`);
      }
    },

    PopupGotopgnum(index) {
      this.PopupCurrentPage = 1;
      if (index > 0) {
        this.PopupCurrentPage = Math.min(
          Math.max(1, index),
          this.PopupTotalPages
        );
        this.showAllCandidates();
        this.PopupGoToPage = null;
      }
    },
    closeCandidateModal() {
      this.searchPopUpCandidates = "";
      this.allSelected = false;
      this.jdSelectCand = [];
      this.$bvModal.hide("modal-center");
      this.PopupShowfiltercard = false;
      this.PopupClearfilter();
      this.searchPopUpCandidates = "";
    },
    async addtojd() {
      try {
        this.showSpinner = true;
        this.LoaderStatus = true;
        let data = {
          candidateIDs: this.jdSelectCand,
          jobIDs: [this.$route.query.jobID],
        };
        const response = await addtojd(data);
        if (response.status == 200) {
          this.closeCandidateModal();
          this.showSpinner = false;
          this.getJobDetails();
          this.$bvModal.hide("modal-center");
          this.successModal("Candidate added successfully!");
          this.LoaderStatus = false;
          this.getPerticularJobDescription();
        }
      } catch (error) {
        this.showSpinner = false;
        this.LoaderStatus = false;
        this.errorModal("Something went Wrong!");
        this.$bvModal.hide("modal-center");
        throw new Error(`Failed! Adding Candidate:${error.status}`);
      }
    },

    downloadasmntresume(data) {
      window.open(data);
    },
    notInterestedCandidates(data) {
      this.notInterestedCandidate = data;
      this.notInterestedRemarks = "";
      this.$v.notInterestedRemarks.$reset();
      this.$bvModal.show("notInterested");
    },

    async cancelMeeting(Details) {
      this.showSpinner = true;
      const response = await getScheduledInterview(Details.kanbanInterviewID);
      if (response.status == 200) {
        this.cancelCandidate = response.data.data;
        this.meetingID = response.data.data.interviewRound.meetingID;
        this.roomId = response.data.data.interviewRound.roomId;

        this.showSpinner = false;
        this.$bvModal.show("cancel-modal");
      } else {
        this.errorModal("Something went wrong");
      }
    },

    async downloadMultipleTemplate() {
      try {
        const res = await downloadTemplate();
        if (res.status == 200) {
          window.open(res.data.data.downloadLink);
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    getResumeName(resumeLink) {
      return resumeLink
        .substring(resumeLink.lastIndexOf("/") + 1)
        .split("?")[0];
    },

    // FUNCTION FOR UPLOADING EXCEL AND POPULATING FAILED AND PASSED CANDIDATES ARRAY
    async uploadExcel() {
      try {
        this.showExcelSpinner = true;
        this.LoaderStatus = true;
        let form = new FormData();
        form.append("excel", this.excelFile);
        form.append("sheetName", JSON.stringify(this.excelSheetNameShow));
        form.append("jobID", this.$route.query.jobID);
        form.append("customerID", this.$route.query.customerID);
        const res = await uploadExcel(form);
        this.showselecteddropdown = false;
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.passedExcCandidates = res.data.data.passedCandidates;
          for (let i in this.passedExcCandidates) {
            if (!this.passedExcCandidates[i].resume) {
              this.passedExcCandidates[i].resumeName = null;
            } else {
              this.resumeUploaded++;
              this.passedExcCandidates[i].resumeName = this.getResumeName(
                this.passedExcCandidates[i].resumeLink
              );
            }
            this.passedExcCandidates[i].showUploadResume = false;
          }
          this.failedExcCandidates = res.data.data.failedCandidates;
          if (res.data.data.S3link) {
            window.open(res.data.data.S3link);
          }
          if (
            this.passedExcCandidates.length === 0 &&
            this.failedExcCandidates.length > 0
          ) {
            this.excelTabs = 1;
          }
          this.$bvModal.show("modal-multi-excel");
        } else if (res.status == 406) {
          this.LoaderStatus = false;
          this.errorModal(res.data.data.details);
        }
        this.showExcelSpinner = false;
      } catch (error) {
        this.showExcelSpinner = false;
        this.LoaderStatus = false;
        console.error(error);
      }
    },

    goToCanditatePage() {
      this.$router.push({
        path: "/addcandidate/",
        query: {
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          jobTitle: this.$route.query.jobTitle,
          cardName: this.$route.query.cardName,
        },
      });
    },

    kanbanBoard() {
      this.$router.push({
        name: "Kanban",
        query: {
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          jobTitle: this.$route.query.jobTitle,
          cardName: this.$route.query.cardName,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: "kanban",
        },
      });
    },
    openApp() {
      this.$router.push({
        name: "ApplicationTable",
        query: {
          cardName: this.$route.query.cardName,
          jobTitle: this.$route.query.jobTitle,
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: this.$route.query.status,
        },
      });
    },

    async configView() {
      this.$bvModal.show("modal-1");
    },

    moveNextTab() {
      this.configTabIndex++;
    },

    commenterror(inputindex) {
      let checkmark = this.feedbackform.skills[inputindex].mark;

      const test = /^[a-zA-Z0-9]$/.test(checkmark);

      if (!test) {
        this.feedbackform.skills[inputindex].markerror = true;
      } else {
        this.feedbackform.skills[inputindex].markerror = false;
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style>
.jd-no-download {
  cursor: default;
  opacity: 50%;
}
.no-match {
  color: #696969;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.failed-count {
  background-color: #fc451e;
  border-radius: 50%;
  font-size: 9px;
  height: 20px;
  width: 20px;
  color: #ffffff;
  margin-left: 7px;
}

.test-section-tabs .tab-pane {
  height: calc(100vh - 315px);
  overflow-x: hidden;
  overflow-y: auto;
}

.test-section-tabs .nav-tabs {
  background: #faf9f9;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  width: 100%;
}

.slectedcandidate-table-container.jdtablecontainer {
  height: calc(100vh - 110px);
}

.jddetails-parent-1 .vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 18px 7px !important;
  font-size: 1em;
}

.sidetestconfig .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: white;
}

.final-select-options-jd {
  color: #545454;
  font-weight: 500;
  font-size: 14px;
}

.final-select-modal-text-jd {
  color: #545454;
  font-weight: 400;
  font-size: 14px;
}

.feedbk-round-head-jd {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.disabledfieldsetStyle {
  color: var(--bg-tertiary);
  background-color: #ebebeb;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  z-index: 0;
  padding-left: 6px;
  padding-right: 4px;
}

.excel-browse {
  display: none;
}

.panel-un {
  margin-top: 10px;
  margin-left: 15px;
  height: 55px;
  width: 400px;
  background: #e7e8f5;
  border-radius: 3px;
  padding: 5px;
}

.status-text {
  font-weight: 400;
  font-size: 12px;
}

.panel-name {
  font-weight: 400;
  color: #72738e;
  font-size: 14px;
}

.panel-status {
  margin-top: 10px;
  margin-left: 15px;
  height: 55px;
  width: 124px;
  background: #e7e8f5;
  border-radius: 3px;
  padding: 5px;
}

.custom-control-label::before {
  top: 4px;
}

.custom-control-label::after {
  top: 3px;
}

.jd-filter-count {
  width: 19px;
  background: #ff7e47;
  border-radius: 10px;
  height: 19px;
  text-align: center;
  bottom: -7px;
  font-weight: var(--weight-B);
  font-size: var(--size-10);
  padding-top: 2px;
  position: absolute;
  margin-left: 19px;
}

.done-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.resume-name {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80px;
  margin-top: 4px;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  background: #72738e;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
}

.custom-file-uploaded {
  padding: 6px 12px;
  background: #d0f9cf;
  width: 150px;
}

.b-rating.disabled {
  background-color: unset;
  color: #6c757d;
}

.recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.recinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.folder-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #6d6d6d;
}

.qb-dropdown-option-arrow {
  padding: 8.5px 30px;
}

.qb-dropdown-option-arrow:nth-child(even) {
  background: #fdfdfd;
}

.qb-dropdown-option-arrow:nth-child(odd) {
  background: #f4f4f4;
}

.folder-list {
  max-height: 165px;
  overflow: auto;
}

.folder-bar-head {
  font-weight: var(--weight-M);
  font-size: 14px;
  color: #696969;
}

.jddetails-cj-filter-modal {
  padding: 10px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  z-index: 6;
  position: absolute;
  width: 100%;
  max-height: 200px;
  min-height: auto;
  overflow: auto;
}

.search-bar {
  position: relative;
  width: 65%;
}

.inputimage-false {
  position: absolute;
  width: 100%;
  height: 50%;
  left: 0;
  top: 0;
}

.inputimage {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}

.icon-validate {
  margin-right: 15%;
}

input[type="file"] {
  opacity: 0;
}

.sec-addquestext {
  font-weight: var(--weight-LM);
  font-size: var(--size-13);

  text-decoration-line: underline;

  color: var(--bg-tertiary);
}

.sec-addquestext a {
  font-weight: var(--weight-LM);
  font-size: var(--size-13);

  text-decoration-line: underline;

  color: var(--bg-tertiary);
}

.kanbancard-view {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 5px 30px;
  color: #5d4da8;
  font-weight: 500;
  position: absolute;
  bottom: 12px;
  right: 10px;
}

.jdd-kanbancard-view {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 5px 30px;
  color: #5d4da8;
  font-weight: 500;
}

.jdtablecontent tbody {
  display: block;
  border-radius: 5px;
  overflow-x: auto;
  height: calc(100vh - 360px);

  margin-top: 5px;
  width: calc(100% + 15px);
}

.jdtablecontent tbody tr:hover {
  background: #e7e8f5;
}

.jd-firstcard {
  height: 240px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  width: 85%;
}

.jd-secondcard {
  height: 240px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.firstround {
  background: #d8f4f4;
  border-radius: 2px;
  color: #49be9b;
  padding: 3px 25px;
  text-align: center;
}

.jdpanel {
  padding: 3px;

  border: 1px solid #72738e;
  border-radius: 5px;
}

.jdpanel-disable {
  padding: 3px;

  border: 1px solid #c4c4c4;
  border-radius: 5px;
}

.jd-panel-selection {
  background: #ffffff;
  box-shadow: 2px 0px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}

.gridgreencolorDynamic {
  width: 4px;
  height: 45px;
  border-radius: 2px;
  position: absolute;
  left: 0px;
  top: 2px;
  background: #5aa0c2;
}

.jd-firstround {
  background: #7ac5e8;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-secondround {
  background: #6dbde1;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-thirdround {
  background: #64b7dd;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-fourthround {
  background: #61b3d9;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-fifthround {
  background: #5db0d6;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-sixthround {
  background: #489cca;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-seventhround {
  background: #3e92c5;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-eighthround {
  background: #3982b7;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-ninthround {
  background: #4381b6;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-tenthround {
  background: #3271a6;
  border-radius: 3px;
  color: #fafafa;
  padding: 5px 20px;
}

.jd-lastround {
  background: #1a6a9b;
  color: #fafafa;
  border-radius: 3px;
  padding: 5px 20px;
}

.jd-hiderdbox {
  background: #038e00;
  color: #ffffff;
  border-radius: 3px;

  padding: 5px 20px;
}

.jd-opshead-pending {
  background: #ffe8cc;
  color: #ff8c00;
  border-radius: 50px;
  padding: 5px 23px;
}

.jd-opshead-rejected {
  background: #ffd6e0;
  color: #ff3366;
  border-radius: 50px;
  padding: 5px 21px;
}

.jd-opshead-icon {
  padding: 5px;
  border-radius: 50%;
}

.jd-rejectedbox {
  background: #e04a58;
  color: #ffffff;
  border-radius: 3px;

  padding: 5px 20px;
}

.jd-onholdbox {
  background: #ffc145;
  color: #ffffff;
  border-radius: 3px;

  padding: 5px 20px;
}

.jd-nibox {
  background: #a9a9a9;

  color: #ffffff;
  border-radius: 3px;

  padding: 5px 20px;
}

.orclass {
  font-weight: 400;
  font-size: 14px;
  color: #c4c4c4;
}

.orcolclass {
  display: flex;
  justify-content: center;
  align-items: center;
}

.jd-panel-insidecard {
  width: 767px;
  height: 41px;

  background: #f2f2f2;
}

.test-name {
  padding: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  box-shadow: 0px 4px 20px rgb(196 196 196 / 50%);
  border-radius: 8px;
}

.jd-totalmark-heading {
  font-weight: 600;
  font-size: 16px;
  color: #696969;
}

.cp-sec-container {
  background: #f5f5f5;
  padding: 10px;
  max-height: 500px;
}

.jd-totalmarks-marks {
  font-weight: 400px;
  font-size: 16px;
  color: #696969;
}

.jd-section-marks-container {
  background: #fbfbfb;
  border-radius: 0px 5px 5px 0px;
  padding: 15px;
  height: 60px;
}

.feedback-right-container {
  border-radius: 8px;
}

.preview-head-text {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #696969;
}

.preview-feedbck-container {
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 15px;
  overflow: auto;
  height: calc(100vh - 150px);
}

.fdbck-recodn-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 4px 4px;
  padding: 25px;
}

.interskilkls-head {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  word-break: break-all;
}

.interskills-container {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px;
}

.fdbck-right-head-container {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  margin: 5px;
  background: rgba(10, 86, 200, 0.5);
  border-radius: 2px;
}

.fdbck-right-detail-container {
  background: #ffffff;
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  height: calc(100vh - 195px);
  overflow: auto;
  margin: 5px 0px;
}

.preview-feedbackform-main-card {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  padding: 10px;
  width: 300px;
  margin: 15px;
  height: calc(90vh - 140px);
  overflow: auto;
  position: relative;
}

.preview-feedbackform-header h5 {
  font-weight: 600;
  font-size: 14px !important;
  color: #696969;
  padding: 15px;
  padding-bottom: 0;
}

.b-rating.disabled {
  background-color: none;
}

.ssbox {
  background: #fdfdfd;
  border: 0.3px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1px;

  height: 87px;
}

.give-text {
  margin-left: 3px;
  font-weight: 600;
  font-size: 12px;
  line-height: 9px;

  color: #535461;
}

.jd-or-style {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;

  color: #72738e;
}

.not-add {
  font-weight: normal;
  font-size: 5px;
  line-height: 7px;

  color: #72738e;
}

.add-notepreview {
  font-weight: normal;
  font-size: 10px;
  line-height: 7px;
  margin-top: 14px;

  color: #72738e;
}

.hov {
  width: 100px;
  height: 30px;
  background: rgba(255, 0, 0, 0.5) !important;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  border: unset;
  line-height: 15px;
}

.button-previewcust {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
  visibility: hidden;

  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(4px);
}

.preview-feedbackform-main-card:hover .button-previewcust {
  visibility: visible;
}

.hov-two {
  top: 10px;
  width: 100px;
  height: 30px;
  background: rgba(10, 86, 200, 0.5) !important;
  border-radius: 6px;
  border: unset;
  font-weight: 500;
  margin-top: 20px;
  font-size: 14px;
  line-height: 15px;
  color: #ffffff;
}

.basic-txt {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: #696969;
}

.preview-feedbackform-main-card.cards-form {
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px rgb(86 86 86 / 20%);
  border-radius: 5px;
  padding: 10px;
  width: unset;
  margin: 15px;
  height: calc(90vh - 50px);
  overflow: auto;
}

.overflow-hide:hover {
  overflow: hidden;
}

.ssbox.hover-new {
  background: #fdfdfd;
  border: 0.3px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1px;

  height: 87px;
}

.sidetestconfig .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  font-size: 14px;

  color: #72738e;
}

.sidetestconfig a {
  color: #495057;

  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}

.sidetestconfig .sidedatetime input {
  overflow: visible;
  background: none;
  border: 1px solid var(--input-border);
  border-radius: 3px !important;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: var(--size-12);
  color: #6d6d6d;
  width: 100%;
  box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
}

.calender-image {
  position: absolute;
  top: 3px;
  right: 5px;
}

.sidetestconfig .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: none;
}

.sidetestconfig .nav-tabs .nav-link {
  margin-bottom: 1px;
  border: unset;
}

.sidetestconfig a:hover {
  color: #495057;
}

.sidetestconfig .nav-tabs {
  border-bottom: 1px solid #dee2e6;
  justify-content: space-between;
}

.sidetestconfig .nav-link {
  display: block;
  padding: 0.5rem 0rem;
}

.sidetestconfig .nav-tabs .nav-link.active {
  position: relative;
}

.sidetestconfig .nav-tabs .nav-link.active::before {
  content: "";
  height: 5px;
  background-color: #72738e;
  width: 103%;
  position: absolute;
  bottom: -1px;
  border-radius: 5px;
}

.sidetestconfig .tab-pane {
  height: 45vh;
}

.disabledfieldsetStyle {
  color: var(--bg-tertiary);
  background-color: #ebebeb;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  z-index: 5;
  padding-left: 6px;
  padding-right: 4px;
}

.testconfig-topDiv > .inputField {
  border: 1px solid #bbbbbb;
  border-radius: 3px !important;
  font-size: var(--size-12);
  color: #6d6d6d;
  box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
  box-sizing: border-box;
}

.testconfig-saveproceed {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.body-viewtrue-col {
  width: 100%;
}

.testconfig-tp-text {
  font-weight: var(--weight-M);
  font-size: 11px;
  line-height: 16px;
  color: #696969;
}

.testconfig-pinktext {
  color: var(--bg-secondary);
  font-size: var(--size-12);
  font-weight: var(--weight-LM);
  line-height: 16px;
}

.onclickcolor {
  color: blue;
}

.externalpanel ul {
  flex-wrap: nowrap !important;
}

.jd-totalmarks > div:nth-child(2) {
  color: green;
}

.downloadTmplateText {
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  color: #72738e;
}

.internal-panelist-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #72738e;
}

.internal-panelist-text-disable {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #c4c4c4;
}

.uploadfile-container {
  background: #f6f6f6;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
}

.dropdown-container {
  padding: 5px 15px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
  border-radius: 5px;
  position: absolute;
  width: 90%;
  z-index: 3;
}

.aoesearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.aoeinput > input {
  padding: 0.75rem 1.25rem !important;
  border: unset;
  border-radius: unset;
  border-bottom: 1px solid #ced4da;
}

.secdropdowncolor:nth-child(odd) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: #f4f4f4;
}

.secdropdowncolor:nth-child(even) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: var(--bg-white);
}

.selectedsheet-box {
  margin: 3px;
  padding: 5px 10px;
  background: #f1f1f1;
  font-weight: 400;
  font-size: 13px;
  color: #565656;
}

.selectedsheet-container {
  background: #ffffff;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}

.jd-candidateToggle {
  position: absolute;
  top: 40px;
  right: 50px;
  background: #ffffff;
  border: 0.2px solid #8a8b8c;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  border-radius: 5px;
  padding: 10px;
  z-index: 3;
  width: 240px !important;
}

.jd-candidateToggle > div:nth-child(odd) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: #f4f4f4;
}

.jd-candidateToggle > div:nth-child(even) {
  font-weight: 400;
  font-size: 13px;
  padding: 0.5rem 1.75rem !important;
  color: #545454;
  background: var(--bg-white);
}

.jd-candidateToggle > div:hover {
  background: #6c757d;
  color: white;
}

.upload-cand-modal > thead {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.scroll-flow {
  overflow-y: auto;
  overflow-x: hidden;
  color: #72738e;
  height: calc(100vh - 225px);
  display: block;
  border-radius: 5px;
  margin-top: 2px;
  width: calc(100% - -7px);
}

/* VIEW DOCUMENTS FONTS */

.candidateJd-z-index {
  z-index: 3;
}

.schedule-meeting-style {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;

  color: #696969;
}

.jd-panel-selection-card {
  width: 739px;
  padding: 10px;

  background: #f2f2f2;
}

.internal-selected-text {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height */

  color: #696969;
}

.availability-class {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.jdd-xMarkCancel {
  position: absolute;
  top: -25px;
  right: -25px;
  border-radius: 50px;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #72738e;
  cursor: pointer;
}

.jdd-rejectedsched-roundname-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.jdd-rejectedsched-roundtype-text {
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}

.jddetails-parent
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: var(--bg-tertiary);
}

.jddetails-parent
  .custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: var(--bg-tertiary);
}

.svg-container {
  display: inline-block;
  position: relative;

  width: 100%;

  padding: auto;

  vertical-align: top;

  overflow: hidden;
}

.svg-content {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
}

.svg-content-responsive {
  display: inline-block;
  position: relative;
  top: 10px;
  left: 0;
}

.jd-configure-box {
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  font-weight: 400;
  font-size: 13px;
  color: #72738e;
}

.jd-modal-sub-head {
  font-weight: 600;
  font-size: 12px;
  color: #696969;
}

.jd-card-sub-head {
  font-weight: 400;
  font-size: 9px;
  color: #6d6d6d;
}

.testconfigfieldsetStyle {
  color: var(--bg-tertiary);
  background: #f4f4f4;
  position: absolute;
  left: 0.5vw;
  top: -9px;
  font-size: var(--size-10);
  line-height: 18px;
  padding-left: 6px;
  padding-right: 4px;
}

.createjobspage .form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.startdateconfig > input {
  border: 1px solid #bbbbbb;
  box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
  border-radius: 3px;
  z-index: 5;
  padding: 7px;
  font-size: var(--size-12);
  background: #e9ecef;
  color: #6d6d6d;
}

.configlabels {
  font-weight: 400;
  font-size: 14px;

  color: #72738e;
}

.dropdown-topDiv > .rjd-dropdown-diffy {
  background: #e9ecef;
  border-radius: 3px;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  border: 1px solid #bbbbbb;
  font-size: var(--size-12);
  color: #6d6d6d;
  box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
  box-sizing: border-box;
}

.jd-modalheight {
  min-height: auto;
  max-height: 63vh;
  overflow: auto;
}

.createjobs-basicdetails .custom-control-label {
  color: #72738e;
  font-size: 12px;
}

.cke_inner {
  display: block;
  background: white !important;
  height: 140px !important;
  padding: 0;
  -webkit-touch-callout: none;
  border-radius: 5px !important;
}

.jd-max-size {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #72738e;
}

.cke_contents {
  display: block;
  height: 95px !important;
  overflow: hidden;
}

.height-dropdown-container {
  min-height: auto;
  max-height: 180px;
  overflow: auto;
}

.jdinputfile .custom-file label {
  text-align: center;

  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2372738EFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 13px;
  border: unset;
}

.jdinputfile .custom-file-label::after {
  display: none !important;
  cursor: pointer;
}

.jdinputfile input {
  height: 100%;
  z-index: 656 !important;
  cursor: pointer;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: unset;
  box-shadow: unset;
}

.custom-file-input:lang(en) ~ .custom-file-label:after {
  cursor: pointer;
}

input#file-upload-button {
  cursor: pointer;
}

.jdkanban .custom-control-label::before {
  position: absolute;
  top: 2px;
}

.jdkanban .custom-control-label::after {
  position: absolute;
  top: 2px;
}

.funnel-textShow {
  background: rgba(242, 242, 242, 0.62);
  border: 0.5px solid #e5e5e5;
  border-radius: 9px;
  padding: 15px 10px;
}

.funnelDataNum {
  font-weight: 600;
  font-size: 14px;
  color: #5d5d5d;
}

.funnelData-text {
  font-weight: 400;
  font-size: 10px;
  color: #696969;
}

.jdd-opshd-outline {
  border-radius: 3px;
  border: 0.7px solid rgba(10, 86, 200, 0.5);
  background: #fdfdfd;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25) inset;
  padding: 6px 10px;
}

.topDiv > .jdd-inputField {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  background: #fdfdfd;
  border-radius: 3px !important;
  z-index: 1;
  padding-left: 10px;
  border: 0.7px solid rgba(10, 86, 200, 0.5);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25) inset;
  overflow-y: auto !important;
}

.jdd-drop-ops {
  position: absolute;
  z-index: 3;
  border-radius: 5px;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  background: #fff;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
}

.jdd-drop-ops .form-control {
  border: 1px solid transparent !important;
  padding: 7px !important;
}

.jdd-ops-overflow {
  height: 140px;
  overflow: auto;
}

.jdd-purple {
  border-radius: 16px;
  background: linear-gradient(315deg, #5d4da8 0%, #c7b0fe 100%);
  height: 110px;
  padding: 10px;
}

.jdd-yellow {
  border-radius: 16px;
  background: linear-gradient(
    299deg,
    #ffb750 30.06%,
    rgba(255, 201, 125, 0.59) 100%
  );
  height: 110px;
  padding: 10px;
}

.jdd-card-text {
  color: var(--white, #fff);
  font-size: 26px;
  font-weight: 600;
}

.jdd-app-num {
  color: var(--white, #fff);
  font-size: 20px;
}

::-webkit-scrollbar {
  width: 7px;
  height: 5px;
}

.jd-textarea-1::placeholder {
  color: #8a8b8c;
}

/* filter for add from talent pool */
.addTP-filter-count {
  width: 19px;
  background: #ff7e47;
  border-radius: 10px;
  height: 19px;
  text-align: center;
  font-weight: var(--weight-B);
  font-size: var(--size-10);
  padding-top: 2px;
  position: absolute;
  margin-left: 50px;
}
#modal-center
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #ebebeb;
  cursor: default;
}

#modal-center .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  cursor: default;
}
#sendmultiasessmodal .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  cursor: default;
}
#sendmultiasessmodal
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #ebebeb;
}

#sendmultiasessmodal
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::after {
  background-color: #ebebeb;
  background-image: none;
  border: 1px solid #adb5bd;
  border-radius: 0.25rem;
}

#modal-center
  .custom-checkbox
  .custom-control-input:disabled:checked
  ~ .custom-control-label::after {
  background-color: #ebebeb;
  background-image: none;
  border: 1px solid #adb5bd;
  border-radius: 0.25rem;
}

.jd-filterinputField {
  width: 226px;
}
</style>
